var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagewithflage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 293.655,
    height: 309.878,
    viewBox: "0 0 293.655 309.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151004",
    "data-name": "Rectangle 151004",
    width: 293.655,
    height: 309.878,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150981",
    "data-name": "Rectangle 150981",
    width: 1.885,
    height: 1.839,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150982",
    "data-name": "Rectangle 150982",
    width: 19.991,
    height: 15.617,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150983",
    "data-name": "Rectangle 150983",
    width: 11.005,
    height: 8.64,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150984",
    "data-name": "Rectangle 150984",
    width: 1.889,
    height: 1.884,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150985",
    "data-name": "Rectangle 150985",
    width: 24.262,
    height: 1.957,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150986",
    "data-name": "Rectangle 150986",
    width: 34.08,
    height: 12.194,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150987",
    "data-name": "Rectangle 150987",
    width: 1.891,
    height: 1.885,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150988",
    "data-name": "Rectangle 150988",
    width: 24.264,
    height: 2.012,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150989",
    "data-name": "Rectangle 150989",
    width: 1.881,
    height: 1.835,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150990",
    "data-name": "Rectangle 150990",
    width: 19.428,
    height: 16.361,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150991",
    "data-name": "Rectangle 150991",
    width: 10.783,
    height: 8.979,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150992",
    "data-name": "Rectangle 150992",
    width: 26.23,
    height: 20.082,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150993",
    "data-name": "Rectangle 150993",
    width: 16.228,
    height: 7.803,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150994",
    "data-name": "Rectangle 150994",
    width: 30.693,
    height: 32.168,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150995",
    "data-name": "Rectangle 150995",
    width: 10.132,
    height: 34.691,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150996",
    "data-name": "Rectangle 150996",
    width: 16.893,
    height: 17.055,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150997",
    "data-name": "Rectangle 150997",
    width: 2.144,
    height: 2.144,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150998",
    "data-name": "Rectangle 150998",
    width: 1.787,
    height: 1.783,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150999",
    "data-name": "Rectangle 150999",
    width: 23.56,
    height: 1.861,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151000",
    "data-name": "Rectangle 151000",
    width: 11.36,
    height: 2.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151001",
    "data-name": "Rectangle 151001",
    width: 21.9,
    height: 5.686,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151002",
    "data-name": "Rectangle 151002",
    width: 4.601,
    height: 9.797,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151003",
    "data-name": "Rectangle 151003",
    width: 19.13,
    height: 26.938,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170241",
    "data-name": "Group 170241",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38544",
    "data-name": "Path 38544",
    d: "M96.69,187.407l-10.1,3.7-5.324,11.213C81.018,204.636,75.2,228,75.2,228l-5.818,20.8C80.522,253.9,95.3,261.164,110.1,260.577l1.9-17.842,10.15-38.78L114.4,188.57l-2.649-.355Z",
    transform: "translate(-22.696 -61.303)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38545",
    "data-name": "Path 38545",
    d: "M29.955,409.952l-7.6,9.922s7.531,11.062,6.3,13.032L8.887,418.852,20.1,402.907Z",
    transform: "translate(-2.907 -131.796)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170174",
    "data-name": "Group 170174",
    transform: "translate(12.664 282.823)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170173",
    "data-name": "Group 170173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170172",
    "data-name": "Group 170172",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38546",
    "data-name": "Path 38546",
    d: "M20.1,420.366a.99.99,0,0,0-1.213.524.952.952,0,0,0,.509,1.207,1.045,1.045,0,0,0,1.282-.562.988.988,0,0,0-.669-1.2",
    transform: "translate(-18.82 -420.313)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170177",
    "data-name": "Group 170177",
    transform: "translate(5.98 285.494)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170176",
    "data-name": "Group 170176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170175",
    "data-name": "Group 170175",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38547",
    "data-name": "Path 38547",
    d: "M8.887,425.845l1.193-1.563,18.507,14.059s.608,1.009.067,1.558Z",
    transform: "translate(-8.887 -424.282)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38548",
    "data-name": "Path 38548",
    d: "M28.221,428c-.072.094-.585-.205-1.281-.233-.7-.045-1.237.2-1.3.1-.075-.082.478-.556,1.32-.508s1.344.57,1.26.644",
    transform: "translate(-8.385 -139.792)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38549",
    "data-name": "Path 38549",
    d: "M30.521,431.626c-.044.109-.579-.025-1.2.151-.623.157-1.02.54-1.113.467-.1-.049.234-.662,1.006-.865s1.367.154,1.3.247",
    transform: "translate(-9.223 -141.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38550",
    "data-name": "Path 38550",
    d: "M30.769,436.12c-.1-.042.106-.62.73-.972s1.225-.242,1.208-.133-.5.194-1,.491-.831.672-.934.614",
    transform: "translate(-10.057 -142.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38551",
    "data-name": "Path 38551",
    d: "M30.644,423.976c-.1.059-.451-.389-1.023-.74s-1.119-.481-1.11-.6c-.007-.11.662-.172,1.33.25s.905,1.047.8,1.089",
    transform: "translate(-9.326 -138.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170180",
    "data-name": "Group 170180",
    transform: "translate(12.587 276.085)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170179",
    "data-name": "Group 170179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170178",
    "data-name": "Group 170178",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38552",
    "data-name": "Path 38552",
    d: "M29.711,417.169l-1.353,1.77-9.653-7,1.15-1.644Z",
    transform: "translate(-18.706 -410.299)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38553",
    "data-name": "Path 38553",
    d: "M32.793,419.949c-.028.04-.452-.171-.986-.709A5.434,5.434,0,0,1,31,418.186a5.757,5.757,0,0,1-.354-.706,1.47,1.47,0,0,1-.133-.446.517.517,0,0,1,.32-.545.652.652,0,0,1,.58.08,1.593,1.593,0,0,1,.335.316,4.361,4.361,0,0,1,.465.649,4.289,4.289,0,0,1,.487,1.248A2.033,2.033,0,0,1,32.708,420c-.067,0-.075-.46-.293-1.143a4.827,4.827,0,0,0-.529-1.125,4.512,4.512,0,0,0-.444-.579c-.17-.2-.347-.332-.467-.277-.045.022-.057.034-.057.127a1.223,1.223,0,0,0,.1.326,6.34,6.34,0,0,0,.31.671,6.753,6.753,0,0,0,.7,1.047c.454.561.808.852.769.9",
    transform: "translate(-9.978 -136.227)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38554",
    "data-name": "Path 38554",
    d: "M33.567,420.4a1.931,1.931,0,0,1,.419-1.142,3.941,3.941,0,0,1,1.585-1.41,1.006,1.006,0,0,1,.987-.051.568.568,0,0,1,.217.57,1.651,1.651,0,0,1-.156.435,2.7,2.7,0,0,1-.474.668,2.785,2.785,0,0,1-1.15.722,1.566,1.566,0,0,1-1.22.028,9.78,9.78,0,0,0,1.117-.3,2.782,2.782,0,0,0,.974-.707,2.525,2.525,0,0,0,.389-.586c.118-.232.159-.458.066-.492a.7.7,0,0,0-.577.079,4.027,4.027,0,0,0-.627.362,4.388,4.388,0,0,0-.894.852c-.439.561-.593,1-.656.973",
    transform: "translate(-10.976 -136.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38555",
    "data-name": "Path 38555",
    d: "M121.828,423.278,117.442,434.3s12.585,4.55,12.745,6.867l-24.253.2,3.781-18.023Z",
    transform: "translate(-34.652 -138.46)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170183",
    "data-name": "Group 170183",
    transform: "translate(74.583 294.81)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170182",
    "data-name": "Group 170182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170181",
    "data-name": "Group 170181",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38556",
    "data-name": "Path 38556",
    d: "M111.538,438.17a.99.99,0,0,0-.676,1.136.951.951,0,0,0,1.12.679,1.044,1.044,0,0,0,.709-1.206.988.988,0,0,0-1.243-.578",
    transform: "translate(-110.84 -438.128)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170186",
    "data-name": "Group 170186",
    transform: "translate(71.281 300.948)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170185",
    "data-name": "Group 170185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170184",
    "data-name": "Group 170184",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38557",
    "data-name": "Path 38557",
    d: "M105.933,449.206l.411-1.957,22.875.54s1.083.461.968,1.223Z",
    transform: "translate(-105.933 -447.249)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38558",
    "data-name": "Path 38558",
    d: "M122.55,439.423c0,.118-.595.177-1.174.562-.59.37-.886.886-1,.84-.11-.022.061-.731.771-1.186s1.423-.325,1.4-.216",
    transform: "translate(-39.368 -143.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38559",
    "data-name": "Path 38559",
    d: "M126.637,440.986c.028.114-.483.32-.881.824s-.51,1.035-.628,1.031c-.112.02-.2-.673.308-1.291s1.2-.677,1.2-.564",
    transform: "translate(-40.903 -144.237)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38560",
    "data-name": "Path 38560",
    d: "M129.524,444.519c-.108.026-.277-.565.022-1.215s.85-.914.9-.815c.068.1-.289.448-.526.986s-.279,1.031-.4,1.044",
    transform: "translate(-42.321 -144.737)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38561",
    "data-name": "Path 38561",
    d: "M123.785,435.93c-.048.108-.593-.05-1.262,0s-1.189.267-1.252.165c-.069-.085.435-.528,1.225-.576s1.346.318,1.289.411",
    transform: "translate(-39.667 -142.462)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38562",
    "data-name": "Path 38562",
    d: "M123.557,433.038a2.272,2.272,0,0,1-1.215,0,5.465,5.465,0,0,1-1.274-.38,5.76,5.76,0,0,1-.7-.365,1.468,1.468,0,0,1-.369-.283.515.515,0,0,1-.059-.629.649.649,0,0,1,.516-.276,1.605,1.605,0,0,1,.456.059,4.384,4.384,0,0,1,.758.253,4.289,4.289,0,0,1,1.126.726c.567.517.762.957.722.981-.053.039-.33-.329-.906-.755a4.841,4.841,0,0,0-1.088-.6,4.6,4.6,0,0,0-.7-.209c-.257-.066-.476-.066-.541.049-.024.044-.026.061.028.136a1.207,1.207,0,0,0,.271.206,6.408,6.408,0,0,0,.645.361,6.71,6.71,0,0,0,1.178.441,8.51,8.51,0,0,1,1.153.281",
    transform: "translate(-39.207 -141.021)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38563",
    "data-name": "Path 38563",
    d: "M125.145,432.1a1.936,1.936,0,0,1-.33-1.171,3.934,3.934,0,0,1,.155-1.331,4,4,0,0,1,.3-.74,1.006,1.006,0,0,1,.77-.619.565.565,0,0,1,.51.335,1.646,1.646,0,0,1,.128.444,2.691,2.691,0,0,1,.007.818,2.788,2.788,0,0,1-.509,1.259c-.469.632-.962.778-.972.738-.04-.059.371-.291.729-.9a2.793,2.793,0,0,0,.375-1.145,2.5,2.5,0,0,0-.028-.7c-.04-.257-.139-.464-.235-.437-.12,0-.324.2-.421.4a4.029,4.029,0,0,0-.3.66,4.381,4.381,0,0,0-.225,1.215c-.028.712.1,1.154.038,1.173",
    transform: "translate(-40.827 -140.082)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38564",
    "data-name": "Path 38564",
    d: "M161.6,125.631l-3.728,25.352-17.084,16.374,6.328,10.907,19.393-18.106a7.878,7.878,0,0,0,2.91-4.486l0-26.208-.127-8.535Z",
    transform: "translate(-46.053 -39.558)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38565",
    "data-name": "Path 38565",
    d: "M52.912,275.719c-.5,1-9.677,48.651-9.677,48.651L17.591,366.095,30.92,375.8,62.6,334.511l17.325-52.48Z",
    transform: "translate(-5.754 -90.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38566",
    "data-name": "Path 38566",
    d: "M112.909,282.352c.748.5,20.364,41.431,20.115,44.42s-15.04,57.636-15.04,57.636l-15.065-2.775,9.334-53.312L94.547,303.465l5.78-22.617Z",
    transform: "translate(-30.928 -91.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38567",
    "data-name": "Path 38567",
    d: "M146.758,176.5l-9.723,8.075-1.817.286,7.324,16.173,13.495-10.9Z",
    transform: "translate(-44.232 -57.735)",
    fill: "#76c8ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38568",
    "data-name": "Path 38568",
    d: "M96.69,187.407l-10.1,3.7-5.324,11.213C81.018,204.636,75.2,228,75.2,228l-5.818,20.8C80.522,253.9,95.3,261.164,110.1,260.577l1.9-17.842L122.243,203.6,114.4,188.57l-2.649-.355Z",
    transform: "translate(-22.696 -61.303)",
    fill: "#0c7c8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38569",
    "data-name": "Path 38569",
    d: "M124.872,173.69c.242-1.867.449-3.424.487-3.613,0,0,6.391.234,7.666-5.954.616-2.99,1.384-9.254,2.014-14.927a11.769,11.769,0,0,0-9.469-12.847l-.6-.116c-6.526-.871-10.912,4.186-11.6,10.735l-3.138,23.907s6.047,5.4,9.573,7.135c4.559,2.245,5.065-4.319,5.065-4.319",
    transform: "translate(-36.059 -44.531)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38570",
    "data-name": "Path 38570",
    d: "M129.037,184.569a14.688,14.688,0,0,1-7.643-3.862s1.048,4.834,7.347,5.472Z",
    transform: "translate(-39.71 -59.112)",
    fill: "#ffb394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38571",
    "data-name": "Path 38571",
    d: "M142.748,159.549c-.131.108-.968-.259-2.134-.176s-2.008.549-2.138.458c-.064-.04.067-.227.433-.442a4.018,4.018,0,0,1,1.707-.489,3.681,3.681,0,0,1,1.7.263c.366.167.494.337.429.386",
    transform: "translate(-45.292 -51.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38572",
    "data-name": "Path 38572",
    d: "M128.414,157.76c-.164.037-.751-.653-1.829-1.095s-2.032-.4-2.108-.54c-.04-.063.159-.17.579-.2a4.063,4.063,0,0,1,1.737.324,3.708,3.708,0,0,1,1.406.981c.254.308.293.513.215.528",
    transform: "translate(-40.716 -51.004)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38573",
    "data-name": "Path 38573",
    d: "M128.786,160.667a.7.7,0,0,1-.793.563.666.666,0,0,1-.585-.753.7.7,0,0,1,.792-.563.667.667,0,0,1,.587.754",
    transform: "translate(-41.674 -52.308)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38574",
    "data-name": "Path 38574",
    d: "M142.757,163.173a.7.7,0,0,1-.793.563.666.666,0,0,1-.585-.753.7.7,0,0,1,.792-.563.667.667,0,0,1,.587.754",
    transform: "translate(-46.244 -53.127)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38575",
    "data-name": "Path 38575",
    d: "M133.377,164.856a6.412,6.412,0,0,1,1.6.02c.248.022.488.018.561-.14a1.261,1.261,0,0,0-.023-.753l-.362-1.992a32.57,32.57,0,0,1-.68-5.161,32.391,32.391,0,0,1,1.093,5.094q.173,1.046.33,2a1.439,1.439,0,0,1-.058.98.625.625,0,0,1-.469.278,1.673,1.673,0,0,1-.425-.023,6.3,6.3,0,0,1-1.57-.3",
    transform: "translate(-43.629 -51.301)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38576",
    "data-name": "Path 38576",
    d: "M128.891,151.036c-.128.22-.947-.054-1.957-.122-1.009-.089-1.862.056-1.952-.181-.038-.113.143-.308.509-.475a3.309,3.309,0,0,1,2.978.231c.333.221.479.441.422.547",
    transform: "translate(-40.882 -49.07)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38577",
    "data-name": "Path 38577",
    d: "M143.378,155.647c-.133.176-.925-.131-1.912-.278-.984-.166-1.824-.119-1.906-.33-.035-.1.149-.25.512-.359a3.488,3.488,0,0,1,1.494-.068,3.6,3.6,0,0,1,1.414.532c.32.219.457.42.4.5",
    transform: "translate(-45.651 -50.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38578",
    "data-name": "Path 38578",
    d: "M112.008,158.945c-.1-.066-4.019-2.085-4.7,2.183s3.741,4.074,3.768,3.952.935-6.135.935-6.135",
    transform: "translate(-35.077 -51.818)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38579",
    "data-name": "Path 38579",
    d: "M110.569,163.9c-.017-.016-.083.041-.217.078a.754.754,0,0,1-.558-.078,1.864,1.864,0,0,1-.587-1.787,2.5,2.5,0,0,1,.379-1.031.869.869,0,0,1,.651-.48.383.383,0,0,1,.406.274c.038.129,0,.209.019.219s.1-.056.1-.238a.483.483,0,0,0-.125-.295.569.569,0,0,0-.394-.174,1.06,1.06,0,0,0-.883.537,2.55,2.55,0,0,0-.448,1.148,1.954,1.954,0,0,0,.789,2.017.809.809,0,0,0,.7,0c.149-.086.187-.176.174-.187",
    transform: "translate(-35.618 -52.465)",
    fill: "#ffb394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38580",
    "data-name": "Path 38580",
    d: "M130.4,171.521c.06-.1-.751-.454-1.247-1.312a4.822,4.822,0,0,1-.461-1.191c-.088-.325-.16-.532-.207-.523s-.06.22-.031.567a3.181,3.181,0,0,0,.4,1.319,2.584,2.584,0,0,0,1,.968c.312.172.532.206.548.171",
    transform: "translate(-42.013 -55.117)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38581",
    "data-name": "Path 38581",
    d: "M142.782,142.771a1.028,1.028,0,0,0-.405-.648,3.15,3.15,0,0,0-1.568-.449,9.1,9.1,0,0,1-4.532-1.986,21.118,21.118,0,0,0-1.874-2.911,16.045,16.045,0,0,0-4.6-4.535,14.63,14.63,0,0,0-7.679-1.529,5.908,5.908,0,0,0-4.972,4.039,4.545,4.545,0,0,0-4.487-.964l-.035-.02c-1.725.393-2.873,2.03-3.561,3.659s-1.11,3.41-2.183,4.816c-.225.294-.492.647-.367,1a.7.7,0,0,0,.693.405,2.06,2.06,0,0,0,.811-.258l-.711,1.26a3.945,3.945,0,0,0,1.814.094,38.8,38.8,0,0,0,.649,4.589,2.567,2.567,0,0,1,1.7.639c.517.59.661,1.6,1.668,1.343.512-.131,1.081-1.107,1.3-1.587a24.577,24.577,0,0,0,2.282-10.2,7.905,7.905,0,0,1,2.629-1.461l-.082.058c1.819-.4,3.866-.762,5.426.255,1.211.788,1.809,2.212,2.644,3.391a9.887,9.887,0,0,0,6.613,4.062c-.116,1.771-.56,4.242-.676,6.013l1.816-2.644v.014c.146-.192.271-.388.393-.585l.04-.059v-.008a11.033,11.033,0,0,1,.614-.943l.016.017a1.107,1.107,0,0,0,1.781-1.28,2.528,2.528,0,0,0-.468-.6,1.753,1.753,0,0,0,1.607.627,1.376,1.376,0,0,0,1.125-1.236,1.169,1.169,0,0,0-.581-1.013,3.948,3.948,0,0,0,2.288-.227c.47-.2.95-.561.867-1.132",
    transform: "translate(-34.833 -42.735)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38582",
    "data-name": "Path 38582",
    d: "M120.085,138.164a5.455,5.455,0,0,0-.7.5,4.513,4.513,0,0,0-1.206,1.963,7.91,7.91,0,0,0-.349,1.571c-.071.575-.1,1.2-.131,1.852a16.689,16.689,0,0,1-.2,2.057,7.318,7.318,0,0,1-.27,1.066,2.266,2.266,0,0,1-.566,1,.95.95,0,0,1-.918.193,1.421,1.421,0,0,1-.741-.543,3.267,3.267,0,0,1-.414-1.661l.129.031a5.253,5.253,0,0,1-.917,1.22,1.877,1.877,0,0,1-1.295.519,1.214,1.214,0,0,1-.632-.19,1.055,1.055,0,0,1-.387-.483,1.077,1.077,0,0,1-.067-.571.78.78,0,0,1,.258-.462l.059.067a4.06,4.06,0,0,1-1.463.849,3.659,3.659,0,0,1-.435.112.713.713,0,0,1-.154.02.8.8,0,0,1,.149-.043c.1-.028.242-.067.425-.134a4.2,4.2,0,0,0,1.419-.869l.059.067a.807.807,0,0,0-.151.925.935.935,0,0,0,.351.429,1.1,1.1,0,0,0,.573.165,1.758,1.758,0,0,0,1.2-.5,5.192,5.192,0,0,0,.885-1.2l.114-.19.015.221a3.152,3.152,0,0,0,.394,1.587,1.272,1.272,0,0,0,.663.486.8.8,0,0,0,.78-.163,2.141,2.141,0,0,0,.523-.933,7.116,7.116,0,0,0,.266-1.043,16.915,16.915,0,0,0,.2-2.038c.036-.655.068-1.279.145-1.861a7.881,7.881,0,0,1,.371-1.589,4.461,4.461,0,0,1,1.266-1.972,2.559,2.559,0,0,1,.733-.456",
    transform: "translate(-35.884 -45.195)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38583",
    "data-name": "Path 38583",
    d: "M143.9,145.032a.223.223,0,0,1-.055.037l-.17.1a2.077,2.077,0,0,1-.285.138,3.348,3.348,0,0,1-.4.155,5.586,5.586,0,0,1-2.734.164,7.139,7.139,0,0,1-3.609-1.842,12.365,12.365,0,0,1-2.8-4.122c-.365-.811-.643-1.631-.967-2.4a8.358,8.358,0,0,0-1.172-2.07,4.3,4.3,0,0,0-1.672-1.307,3.087,3.087,0,0,0-.937-.222,3.381,3.381,0,0,0-.89.064,3.647,3.647,0,0,0-2.211,1.462,4.369,4.369,0,0,0-.435.9.242.242,0,0,1,.013-.065c.014-.05.032-.112.052-.188a3.16,3.16,0,0,1,.321-.678,3.6,3.6,0,0,1,.813-.866,3.693,3.693,0,0,1,1.424-.666,3.464,3.464,0,0,1,.919-.075,3.162,3.162,0,0,1,.976.222,4.414,4.414,0,0,1,1.731,1.335,8.42,8.42,0,0,1,1.2,2.1c.328.771.608,1.59.969,2.393a12.365,12.365,0,0,0,2.757,4.082,7.093,7.093,0,0,0,3.535,1.839,5.682,5.682,0,0,0,2.7-.117,8.855,8.855,0,0,0,.931-.371",
    transform: "translate(-41.071 -43.684)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38584",
    "data-name": "Path 38584",
    d: "M150.91,146.353a1,1,0,0,1-.243.13,4.952,4.952,0,0,1-.7.259,6.594,6.594,0,0,1-1.093.221,6.843,6.843,0,0,1-2.708-.234,6.482,6.482,0,0,1-1.039-.4,4.945,4.945,0,0,1-.649-.375.944.944,0,0,1-.217-.17c.015-.023.339.2.91.45a7.3,7.3,0,0,0,1.031.368,7.321,7.321,0,0,0,2.657.23,7.368,7.368,0,0,0,1.079-.186c.606-.153.964-.313.974-.287",
    transform: "translate(-47.188 -47.686)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170189",
    "data-name": "Group 170189",
    transform: "translate(61.234 146.536)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170188",
    "data-name": "Group 170188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170187",
    "data-name": "Group 170187",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38585",
    "data-name": "Path 38585",
    d: "M91,217.772s8.443,12.221,14.5,12.121h2.122l1.01-1.815s13.433,2.724,16.443,1.63l-16.645-6.179-3.2,1.865Z",
    transform: "translate(-91.002 -217.772)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38586",
    "data-name": "Path 38586",
    d: "M106.454,218.04s30.277,8.823,33.842,8,25.687-18.549,25.687-18.549l-4.993-6.007-22.847,12.63-27.412-8.7Z",
    transform: "translate(-34.823 -65.909)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38587",
    "data-name": "Path 38587",
    d: "M92.314,192.836s-5.062,1.118-5.808,9.432c-.89,9.925,18.712,17.687,18.712,17.687l9.684-16.2Z",
    transform: "translate(-28.288 -63.079)",
    fill: "#76c8ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38588",
    "data-name": "Path 38588",
    d: "M103.565,202.457a.848.848,0,0,1,.217.08l.613.274,2.31,1.083,8.217,3.947.145.07-.081.141-6.59,11.412-2.143,3.691-.072.123-.134-.047a42.643,42.643,0,0,1-7.769-3.5,29.7,29.7,0,0,1-5.438-4.127,30.462,30.462,0,0,1-4.045-4.656,2.184,2.184,0,0,1,.289.31l.789.927A41.521,41.521,0,0,0,93,215.435a30.446,30.446,0,0,0,5.436,4.031,43.5,43.5,0,0,0,7.728,3.438l-.206.077,2.139-3.693,6.633-11.387.065.211-8.162-4.059-2.274-1.157-.593-.315a.862.862,0,0,1-.2-.122",
    transform: "translate(-29.046 -66.226)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38589",
    "data-name": "Path 38589",
    d: "M143.522,201.871c-.1.036-.931-2-2.155-4.418s-2.362-4.3-2.275-4.359a5.422,5.422,0,0,1,.861,1.165,35.068,35.068,0,0,1,3.143,6.227,5.4,5.4,0,0,1,.426,1.385",
    transform: "translate(-45.497 -63.163)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38590",
    "data-name": "Path 38590",
    d: "M37.4,384.47a1.287,1.287,0,0,1,.135-.206l.425-.583,1.662-2.22,6.165-8.126,20.444-26.727,2.714-3.535-.028.051c3.817-11.489,7.213-21.716,9.663-29.093,1.233-3.66,2.226-6.612,2.919-8.67.345-1,.614-1.785.8-2.338.091-.252.162-.452.217-.6a1.023,1.023,0,0,1,.085-.2,1.119,1.119,0,0,1-.053.212c-.047.155-.108.357-.186.614l-.746,2.357c-.668,2.066-1.628,5.03-2.817,8.7L69.25,343.234l-.009.027-.018.024-2.712,3.536L45.984,373.486l-6.253,8.058-1.714,2.18-.454.562a1.277,1.277,0,0,1-.163.184",
    transform: "translate(-12.234 -98.859)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38591",
    "data-name": "Path 38591",
    d: "M126.368,347.207a14.8,14.8,0,0,1-2.964,1.231,14.816,14.816,0,0,1-3.08.9,14.878,14.878,0,0,1,2.964-1.231,14.759,14.759,0,0,1,3.08-.9",
    transform: "translate(-39.359 -113.572)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38592",
    "data-name": "Path 38592",
    d: "M126.525,352.849a10.387,10.387,0,0,1-2.62-.56,10.4,10.4,0,0,1-2.525-.9,10.344,10.344,0,0,1,2.62.561,10.359,10.359,0,0,1,2.524.9",
    transform: "translate(-39.705 -114.938)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38593",
    "data-name": "Path 38593",
    d: "M118.756,265.275a4.77,4.77,0,0,1-.77.536c-.5.331-1.26.771-2.215,1.278a40.793,40.793,0,0,1-16.132,4.589c-1.077.071-1.951.095-2.555.079a4.818,4.818,0,0,1-.937-.051,4.835,4.835,0,0,1,.933-.085c.6-.026,1.47-.087,2.538-.19a45.858,45.858,0,0,0,16.04-4.564c.963-.475,1.733-.88,2.258-1.174a4.808,4.808,0,0,1,.838-.419",
    transform: "translate(-31.451 -86.774)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38594",
    "data-name": "Path 38594",
    d: "M274.056,423.833l4.5,10.979s-12.536,4.683-12.672,7l24.254-.06-3.97-17.982Z",
    transform: "translate(-86.975 -138.621)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170192",
    "data-name": "Group 170192",
    transform: "translate(197.898 295.081)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170191",
    "data-name": "Group 170191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170190",
    "data-name": "Group 170190",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38595",
    "data-name": "Path 38595",
    d: "M295.286,438.571a.99.99,0,0,1,.687,1.129.952.952,0,0,1-1.113.691,1.046,1.046,0,0,1-.722-1.2.988.988,0,0,1,1.238-.591",
    transform: "translate(-294.103 -438.531)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170195",
    "data-name": "Group 170195",
    transform: "translate(178.901 301.179)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170194",
    "data-name": "Group 170194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170193",
    "data-name": "Group 170193",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38596",
    "data-name": "Path 38596",
    d: "M290.135,449.545l-.432-1.953-22.867.779s-1.079.473-.956,1.233Z",
    transform: "translate(-265.871 -447.592)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38597",
    "data-name": "Path 38597",
    d: "M284.134,439.944c0,.119.6.171,1.18.55s.9.877,1,.83c.109-.024-.069-.731-.784-1.178s-1.426-.309-1.4-.2",
    transform: "translate(-92.944 -143.875)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38598",
    "data-name": "Path 38598",
    d: "M280.357,441.547c-.027.115.486.315.89.815s.521,1.03.639,1.024c.111.018.192-.676-.322-1.288s-1.2-.665-1.207-.552",
    transform: "translate(-91.708 -144.42)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38599",
    "data-name": "Path 38599",
    d: "M277.758,445.109c.108.025.271-.568-.035-1.215s-.86-.905-.909-.806c-.066.1.294.445.536.98s.291,1.029.409,1.04",
    transform: "translate(-90.547 -144.933)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38600",
    "data-name": "Path 38600",
    d: "M282.706,436.461c.05.108.593-.057,1.262-.013s1.192.253,1.254.151c.068-.085-.442-.522-1.231-.563s-1.344.331-1.285.424",
    transform: "translate(-92.476 -142.632)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38601",
    "data-name": "Path 38601",
    d: "M282.34,433.563a2.264,2.264,0,0,0,1.215-.009,5.429,5.429,0,0,0,1.271-.394,5.779,5.779,0,0,0,.7-.371,1.5,1.5,0,0,0,.366-.287.516.516,0,0,0,.052-.63.649.649,0,0,0-.519-.269,1.585,1.585,0,0,0-.455.064,4.292,4.292,0,0,0-1.873,1c-.561.523-.752.966-.712.989.054.039.327-.333.9-.764a4.838,4.838,0,0,1,1.082-.614,4.53,4.53,0,0,1,.7-.217c.257-.068.476-.07.542.044.024.044.028.061-.026.136a1.2,1.2,0,0,1-.269.209,6.34,6.34,0,0,1-.64.369,6.723,6.723,0,0,1-1.174.453,8.417,8.417,0,0,0-1.149.293",
    transform: "translate(-92.357 -141.183)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38602",
    "data-name": "Path 38602",
    d: "M281.608,432.646a1.938,1.938,0,0,0,.318-1.174,3.923,3.923,0,0,0-.48-2.066,1,1,0,0,0-.776-.612.567.567,0,0,0-.507.34,1.646,1.646,0,0,0-.124.446,2.713,2.713,0,0,0,0,.818,2.8,2.8,0,0,0,.521,1.254c.476.627.97.767.98.727.039-.059-.374-.287-.738-.89a2.783,2.783,0,0,1-.387-1.141,2.5,2.5,0,0,1,.02-.7c.038-.258.134-.466.23-.44.121,0,.327.191.426.4a4.027,4.027,0,0,1,.3.658,4.375,4.375,0,0,1,.238,1.211c.035.712-.091,1.156-.026,1.174",
    transform: "translate(-91.595 -140.264)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38603",
    "data-name": "Path 38603",
    d: "M284.923,288.561c-.684.347-25.587,35.186-32.767,44.78a7.325,7.325,0,0,0-1.388,6.146c3.186,12.386,16.245,50.431,16.245,50.431l17.486-3.629-10.984-45.475L300.659,311.7,297.6,288.557Z",
    transform: "translate(-81.965 -94.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38604",
    "data-name": "Path 38604",
    d: "M282.2,366.044a18.166,18.166,0,0,1-4.361-2.506,18.146,18.146,0,0,1,4.361,2.506",
    transform: "translate(-90.885 -118.915)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38605",
    "data-name": "Path 38605",
    d: "M190.792,167.922c.119.069,1.135.573,2.085,1.044a6.281,6.281,0,0,1,2.656,2.49c.719,1.244,1.6,2.749,1.673,2.807.132.1,3.6,2.8,3.6,2.8l-4.895,6.722-1.344-1.087s-4.891-.26-6.731-1.154-3.548-2.349-3.332-2.99.283-.839.283-.839a3.031,3.031,0,0,1-.47-2.19s-1.119-1.293-.915-2.214a2.17,2.17,0,0,1,1.724-1.683s-.546-1.5,0-2.309a2.948,2.948,0,0,1,1.649-1.037l4.576,1.975Z",
    transform: "translate(-59.985 -54.93)",
    fill: "#c78976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38606",
    "data-name": "Path 38606",
    d: "M379.487,422.9l8,9.6s-7.075,11.36-5.769,13.278L400.9,430.933l-11.854-15.476Z",
    transform: "translate(-124.135 -135.901)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170198",
    "data-name": "Group 170198",
    transform: "translate(268.071 291.111)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170197",
    "data-name": "Group 170197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170196",
    "data-name": "Group 170196",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38607",
    "data-name": "Path 38607",
    d: "M398.96,432.7a.991.991,0,0,1,1.233.474.951.951,0,0,1-.46,1.227,1.044,1.044,0,0,1-1.3-.509.988.988,0,0,1,.62-1.223",
    transform: "translate(-398.389 -432.63)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170201",
    "data-name": "Group 170201",
    transform: "translate(257.337 293.518)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170200",
    "data-name": "Group 170200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170199",
    "data-name": "Group 170199",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38608",
    "data-name": "Path 38608",
    d: "M401.866,437.72l-1.255-1.513-17.919,14.8s-.566,1.032,0,1.559Z",
    transform: "translate(-382.438 -436.207)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38609",
    "data-name": "Path 38609",
    d: "M390.8,440.657c.075.091.577-.229,1.27-.285.693-.073,1.244.148,1.3.044.072-.085-.5-.537-1.341-.455s-1.319.624-1.232.7",
    transform: "translate(-127.833 -143.914)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38610",
    "data-name": "Path 38610",
    d: "M388.771,444.383c.049.107.578-.048,1.2.1.629.132,1.041.5,1.131.421.1-.053-.261-.652-1.041-.823s-1.36.208-1.293.3",
    transform: "translate(-127.171 -145.25)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38611",
    "data-name": "Path 38611",
    d: "M388.883,448.884c.1-.046-.132-.614-.77-.942s-1.233-.192-1.212-.083.5.173,1.023.449.858.638.959.575",
    transform: "translate(-126.56 -146.46)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38612",
    "data-name": "Path 38612",
    d: "M388.445,436.72c.1.056.435-.407.992-.78s1.1-.526,1.086-.645-.669-.145-1.319.3-.862,1.083-.759,1.12",
    transform: "translate(-127.058 -142.367)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170204",
    "data-name": "Group 170204",
    transform: "translate(259.001 284.384)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170203",
    "data-name": "Group 170203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170202",
    "data-name": "Group 170202",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38613",
    "data-name": "Path 38613",
    d: "M384.91,429.9l1.424,1.713,9.36-7.383-1.216-1.6Z",
    transform: "translate(-384.91 -422.634)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38614",
    "data-name": "Path 38614",
    d: "M386.106,432.789c.029.04.444-.189.957-.749a5.436,5.436,0,0,0,.766-1.086,5.747,5.747,0,0,0,.325-.719,1.477,1.477,0,0,0,.115-.451.515.515,0,0,0-.342-.53.647.647,0,0,0-.576.1,1.552,1.552,0,0,0-.322.328,4.3,4.3,0,0,0-.875,1.934,2.037,2.037,0,0,0,.039,1.218c.067,0,.056-.463.246-1.154a4.835,4.835,0,0,1,.483-1.146,4.513,4.513,0,0,1,.42-.6c.162-.21.333-.346.456-.3.045.02.058.031.062.124a1.2,1.2,0,0,1-.086.33,6.307,6.307,0,0,1-.283.682,6.69,6.69,0,0,1-.653,1.075c-.43.578-.772.884-.731.934",
    transform: "translate(-126.298 -140.405)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38615",
    "data-name": "Path 38615",
    d: "M384.84,433.314c.044-.011-.03-.49-.465-1.124a3.931,3.931,0,0,0-1.641-1.344,1,1,0,0,0-.988-.011.565.565,0,0,0-.194.578,1.627,1.627,0,0,0,.174.429,2.71,2.71,0,0,0,.5.647,2.789,2.789,0,0,0,1.179.675,1.567,1.567,0,0,0,1.22-.021,9.957,9.957,0,0,1-1.127-.255,2.786,2.786,0,0,1-1-.667,2.505,2.505,0,0,1-.412-.569c-.127-.226-.178-.451-.086-.488a.693.693,0,0,1,.58.055,3.978,3.978,0,0,1,.641.336,4.371,4.371,0,0,1,.929.815c.462.542.633.97.7.945",
    transform: "translate(-124.806 -140.89)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38616",
    "data-name": "Path 38616",
    d: "M340.479,287.372c.377,1.048,4.826,54.828,4.826,54.828l29.989,39.739-12.746,8.887-33.893-34.8a12.07,12.07,0,0,1-3.222-6l-12.528-59.583Z",
    transform: "translate(-102.355 -94.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38617",
    "data-name": "Path 38617",
    d: "M232.683,195.687l26.4.573,1.817.286-7.324,16.173-26.954-3.876-26.471-19.582,7.073-9.9Z",
    transform: "translate(-65.471 -58.671)",
    fill: "#76c8ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38618",
    "data-name": "Path 38618",
    d: "M300.285,202.634l10.133,2.626a8.513,8.513,0,0,1,5.567,5.246l2.848,10.292,5.963,22.936,5.82,20.8c-10.364,4.736-18.577,11.195-31.584,11.6a12.535,12.535,0,0,1-5.3-.988l-8.5-3.617L288,258.467l-10.15-38.781,7.748-15.385,2.648-.355Z",
    transform: "translate(-90.887 -66.284)",
    fill: "#0c7c8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38619",
    "data-name": "Path 38619",
    d: "M253.685,168.829a1.71,1.71,0,0,1,.221-1.155,4.243,4.243,0,0,1,2.222-1.555,11.187,11.187,0,0,0-.252-3.648,2.224,2.224,0,0,1-1.285.116,1.228,1.228,0,0,1-.213.015,1.744,1.744,0,0,1-1.295-2.206,5.049,5.049,0,0,1,1.7-2.319c-.607.277-.979.894-1.5,1.307s-1.439.533-1.749-.059a1.451,1.451,0,0,1-.12-.594q-.039-.617-.075-1.232a1.31,1.31,0,0,1,.188-.952,3.043,3.043,0,0,1,.575-.4c.623-.456.657-1.439,1.275-1.9a3.419,3.419,0,0,1,1.642-.37c.563-.077,1.207-.441,1.173-1.009a5.306,5.306,0,0,1-2.344-.812,1.82,1.82,0,0,1-.657-2.2,2.679,2.679,0,0,1,1.61-1.032c.691-.232,1.6-.4,2.029.183a1.9,1.9,0,0,1,2.7.55l1.683-.853a19.224,19.224,0,0,1-2.156-.807c-.646-.419-.971-1.5-.326-1.916.235-.154.547-.179.753-.37.15-.137.234-.353.42-.433a.73.73,0,0,1,.435,0l4.628.986-1.9-1.939c-.583-.6-1.2-1.488-.733-2.178.454-.667,1.6-.4,2.013.293a1.288,1.288,0,0,1,1.888.543,1.306,1.306,0,0,1,2.149,1.308,3.7,3.7,0,0,1,1.962-.153,1.136,1.136,0,0,1,1.432-1.391,1.973,1.973,0,0,1-.135-1.159c.112-.379.573-.676.912-.474a1.328,1.328,0,0,1,1.538-1.986l.325-.972a1.745,1.745,0,0,1,1.886.209,1.018,1.018,0,0,1-.281,1.644c.436-.176.606.562.487,1.017q-.248.95-.5,1.9a1.469,1.469,0,0,1,1.639-.8,1.135,1.135,0,0,1,1.537-.579.921.921,0,0,1,1.643-.335c0-.328.385-.5.7-.581a2.136,2.136,0,0,1,1.385-.052c.432.188.676.83.323,1.141.293-.355.936-.128,1.107.3a1.644,1.644,0,0,1-.2,1.323,3.862,3.862,0,0,0-.524,1.268,1.948,1.948,0,0,1,1.136-.738,5.037,5.037,0,0,1,2.41-.417c.014-.353.431-.529.779-.587a5.614,5.614,0,0,1,3.227.421c.474.215.979.616.911,1.132a1.384,1.384,0,0,1-.322.624q-.9,1.192-1.806,2.384a6.924,6.924,0,0,1,4.131,1.048,12.013,12.013,0,0,1,1.755.067c.561.176.879,1.093.33,1.3a1.08,1.08,0,0,1,.742,1.055,1.028,1.028,0,0,1-.213.552,1.456,1.456,0,0,1-.147.394,1.977,1.977,0,0,1-.509.58,1.331,1.331,0,0,1-.872.9,5.408,5.408,0,0,1,1.644.9,2.269,2.269,0,0,1,.837,2.179,1.3,1.3,0,0,1-.048.125,1.109,1.109,0,0,1-.2.833.937.937,0,0,1,.307.546,2.483,2.483,0,0,1,2.087,3.86c-.4.6-1.437.915-1.745.268a1.931,1.931,0,0,1-.985,1.525,1.873,1.873,0,0,1,.014,2.758,2,2,0,0,1,.589,3.271,1.528,1.528,0,1,1-2.333,1.974,3.254,3.254,0,0,1-.553,1.748,1.121,1.121,0,0,1-1.624.183,2.1,2.1,0,0,1-2.519,2.042,1.358,1.358,0,0,1-2.433,1.194l-3.282,1.23a12.562,12.562,0,0,1-2.221.678,6.286,6.286,0,0,1-2.937-.192,2.127,2.127,0,0,0-.932-.168,2.184,2.184,0,0,0-.941.54,5.675,5.675,0,0,1-5.485.75,2.829,2.829,0,0,0-.866-.273,2.562,2.562,0,0,0-1.017.238,10.216,10.216,0,0,1-2.509.575,2.708,2.708,0,0,1-2.1-.454c-.55-.493-.547-1.582.146-1.836a1.586,1.586,0,0,0-.844-1.1.954.954,0,0,0-1.227.416c-.189.441.23,1.043.7.93a1.415,1.415,0,0,1-2.333-.369,1.9,1.9,0,0,1,1.136-2.334,4.349,4.349,0,0,1-.814-1.958,1.559,1.559,0,0,1-1.894.989,2.688,2.688,0,0,1-1.173,1.792,1.61,1.61,0,0,1-2.007-.267,1.159,1.159,0,0,1,.49-1.788,1.385,1.385,0,0,1,.427-2.312,2.155,2.155,0,0,1,.4-2.607,1.134,1.134,0,0,1-1.73,0c-.163.817-1.239,1.048-2.062.913a1.514,1.514,0,0,1-1.468-1.2",
    transform: "translate(-82.212 -45.104)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38620",
    "data-name": "Path 38620",
    d: "M253.642,168.759a1.083,1.083,0,0,0,.064.281,1.24,1.24,0,0,0,.541.657,2.73,2.73,0,0,0,1.375.328,2.37,2.37,0,0,0,.9-.184,1.132,1.132,0,0,0,.687-.788l-.075.017a1.181,1.181,0,0,0,1.8.005l-.074-.067a2.215,2.215,0,0,0-.423,2.675l.036-.088a1.337,1.337,0,0,0-.892,1.038,1.366,1.366,0,0,0,.44,1.387l.024-.121a1.168,1.168,0,0,0-.778,1.246,1.28,1.28,0,0,0,1.075,1.143,1.851,1.851,0,0,0,1.632-.462,3,3,0,0,0,.858-1.581l-.107.061a1.648,1.648,0,0,0,2-1.042l-.171-.013a4.469,4.469,0,0,0,.827,2l.04-.14a2.128,2.128,0,0,0-1.043.922,1.786,1.786,0,0,0-.186,1.425,1.489,1.489,0,0,0,1.113.965,1.341,1.341,0,0,0,1.43-.467l.153-.224-.26.069c-.26.069-.543-.184-.6-.474a.609.609,0,0,1,.445-.691.943.943,0,0,1,.922.166,1.635,1.635,0,0,1,.529.878l.067-.127a.915.915,0,0,0-.534.554,1.348,1.348,0,0,0-.042.759,1.331,1.331,0,0,0,.364.676,1.8,1.8,0,0,0,.655.393,3.633,3.633,0,0,0,1.5.127,10.3,10.3,0,0,0,1.486-.246c1-.163,1.922-.951,2.858-.326a5.7,5.7,0,0,0,3.163.34,5.869,5.869,0,0,0,1.566-.5,8.343,8.343,0,0,0,1.376-.909.988.988,0,0,1,.7-.184,5.841,5.841,0,0,1,.784.214,6.486,6.486,0,0,0,1.7.242,8.979,8.979,0,0,0,3.369-.772l3.294-1.231-.161-.058a1.491,1.491,0,0,0,2.672-1.311l-.16.182a2.237,2.237,0,0,0,2.692-2.18l-.242.1a1.019,1.019,0,0,0,.923.312,1.461,1.461,0,0,0,.881-.461,3.285,3.285,0,0,0,.617-1.856l-.246.075a1.669,1.669,0,1,0,2.548-2.157l-.019.2a1.992,1.992,0,0,0,.642-1.873,2.018,2.018,0,0,0-1.275-1.646l.047.247a2.019,2.019,0,0,0-.014-2.981l-.022.24a2.086,2.086,0,0,0,1.061-1.642l-.278.052a.756.756,0,0,0,.387.371.993.993,0,0,0,.514.057,1.655,1.655,0,0,0,.882-.427,2.479,2.479,0,0,0,.647-1.812,2.549,2.549,0,0,0-.8-1.786,2.688,2.688,0,0,0-1.842-.742l.147.124a1.092,1.092,0,0,0-.354-.632l.017.2a1.262,1.262,0,0,0,.23-.946l-.008.073a2.211,2.211,0,0,0-.532-2.168,4.814,4.814,0,0,0-1.987-1.228l-.011.283a1.483,1.483,0,0,0,.974-1l-.051.075a1.871,1.871,0,0,0,.709-1.058l-.026.056a1.125,1.125,0,0,0,.182-1.052,1.228,1.228,0,0,0-.789-.788l.01.284a.571.571,0,0,0,.356-.394.869.869,0,0,0-.03-.5,1.091,1.091,0,0,0-.667-.7,11.347,11.347,0,0,0-1.774-.071l.057.021a7.094,7.094,0,0,0-4.223-1.071l.13.242.828-1.093.627-.828a7.378,7.378,0,0,0,.615-.871.9.9,0,0,0,.071-.6,1.122,1.122,0,0,0-.3-.51,2.531,2.531,0,0,0-.927-.568,5.767,5.767,0,0,0-3.107-.325,1.552,1.552,0,0,0-.53.2.666.666,0,0,0-.341.529l.174-.143a4.294,4.294,0,0,0-1.97.25c-.31.1-.611.2-.921.329a1.622,1.622,0,0,0-.809.651l.28.089c.063-.628.6-1.155.757-1.89a1.121,1.121,0,0,0-.277-1.091.97.97,0,0,0-.543-.244.666.666,0,0,0-.589.224l.213.207a.673.673,0,0,0,.218-.546,1,1,0,0,0-.188-.518.966.966,0,0,0-.433-.341,1.436,1.436,0,0,0-.515-.094,3.671,3.671,0,0,0-.967.166,1.641,1.641,0,0,0-.473.206.618.618,0,0,0-.3.507l.279-.069a1.066,1.066,0,0,0-1.922.391l.217-.118a1.281,1.281,0,0,0-1.746.658l.178-.09a1.613,1.613,0,0,0-1.811.882l.273.1q.212-.81.421-1.612a1.9,1.9,0,0,0,.1-.874.994.994,0,0,0-.172-.448.464.464,0,0,0-.235-.173.457.457,0,0,0-.3.019l.095.275a.991.991,0,0,0,.669-.877,1.225,1.225,0,0,0-.351-1.031,1.9,1.9,0,0,0-2.02-.217l-.059.025-.02.062c-.111.33-.218.651-.325.972l.182-.09a1.471,1.471,0,0,0-1.7,2.2l.191-.2a.687.687,0,0,0-.712.036.938.938,0,0,0-.414.54,2.139,2.139,0,0,0,.141,1.224l.191-.172a1.274,1.274,0,0,0-1.617,1.572l.156-.19A3.841,3.841,0,0,0,268.3,144l.179.167a1.443,1.443,0,0,0-2.375-1.445l.22.051a1.42,1.42,0,0,0-2.1-.6l.2.038a1.592,1.592,0,0,0-.82-.645,1.358,1.358,0,0,0-1.043.02,1.044,1.044,0,0,0-.559.884,1.778,1.778,0,0,0,.288.969,8.4,8.4,0,0,0,1.25,1.435l1.293,1.321.119-.216-2.858-.607-1.4-.3a3.1,3.1,0,0,0-.737-.112.571.571,0,0,0-.374.216c-.085.1-.145.2-.213.265a1.851,1.851,0,0,1-.583.282.917.917,0,0,0-.526.564,1.517,1.517,0,0,0,.383,1.381,2.628,2.628,0,0,0,1.229.663,8.505,8.505,0,0,1,1.243.414v-.211l-1.682.854.153.048a2.007,2.007,0,0,0-2.876-.583l.16.022a1.291,1.291,0,0,0-1.191-.436,4.673,4.673,0,0,0-1.183.291,3.437,3.437,0,0,0-1.069.555,1.473,1.473,0,0,0-.552,1.067,2.182,2.182,0,0,0,1.157,1.919,6.289,6.289,0,0,0,2.091.631l-.081-.092a.772.772,0,0,1-.437.681,1.9,1.9,0,0,1-.854.249,6.346,6.346,0,0,0-.93.117,1.4,1.4,0,0,0-.8.5c-.387.5-.489,1.118-.866,1.513-.172.207-.451.277-.686.491a1.09,1.09,0,0,0-.272.837q.051.827.1,1.62a.956.956,0,0,0,.353.745,1.1,1.1,0,0,0,.789.167,1.776,1.776,0,0,0,.729-.269,3.594,3.594,0,0,0,.558-.5,3.729,3.729,0,0,1,1.046-.891l-.081-.122a8.845,8.845,0,0,0-1.169,1.241,2.851,2.851,0,0,0-.592,1.462,2.1,2.1,0,0,0,.423,1.387,1.3,1.3,0,0,0,1.2.531h-.017a2.258,2.258,0,0,0,1.317-.125l-.072-.036a11.178,11.178,0,0,1,.265,3.632l.023-.031a6.611,6.611,0,0,0-1.563.832,2.462,2.462,0,0,0-.769.965,1.687,1.687,0,0,0-.129.714,1.035,1.035,0,0,0,.033.235,1.759,1.759,0,0,1,.132-.933,2.448,2.448,0,0,1,.768-.935,6.626,6.626,0,0,1,1.558-.807l.021-.009,0-.023a11.117,11.117,0,0,0-.238-3.664l-.014-.06-.058.024a2.155,2.155,0,0,1-1.254.109h-.017a1.176,1.176,0,0,1-1.095-.493,1.978,1.978,0,0,1-.389-1.3,2.735,2.735,0,0,1,.573-1.388,8.791,8.791,0,0,1,1.157-1.215l.343-.316-.424.194a3.829,3.829,0,0,0-1.1.918,3.45,3.45,0,0,1-.532.472,1.632,1.632,0,0,1-.663.242.936.936,0,0,1-.671-.139.792.792,0,0,1-.283-.627q-.044-.786-.091-1.607a.917.917,0,0,1,.22-.707c.177-.17.486-.256.694-.5.424-.454.527-1.077.881-1.521.345-.475.994-.5,1.606-.544a2.106,2.106,0,0,0,.937-.273.966.966,0,0,0,.535-.861l0-.078-.077-.014a6.126,6.126,0,0,1-2.023-.612,1.978,1.978,0,0,1-1.049-1.729,1.258,1.258,0,0,1,.479-.914,3.219,3.219,0,0,1,1-.513,4.429,4.429,0,0,1,1.127-.276,1.072,1.072,0,0,1,.994.347l.068.094.091-.072a1.783,1.783,0,0,1,2.534.518l.056.1.1-.049,1.684-.85.213-.108-.215-.1a8.61,8.61,0,0,0-1.277-.431,2.418,2.418,0,0,1-1.119-.6,1.286,1.286,0,0,1-.33-1.147.665.665,0,0,1,.392-.412,1.941,1.941,0,0,0,.657-.331c.186-.2.274-.4.443-.41a3.233,3.233,0,0,1,.655.11l1.4.3,2.857.612.417.089-.3-.305-1.291-1.322a8.266,8.266,0,0,1-1.208-1.387,1.526,1.526,0,0,1-.25-.822.776.776,0,0,1,.413-.659,1.283,1.283,0,0,1,1.513.525l.079.129.118-.091a1.155,1.155,0,0,1,1.68.484l.073.189.147-.139a1.169,1.169,0,0,1,1.923,1.172l-.073.259.254-.091a3.567,3.567,0,0,1,1.889-.147l.26.05-.1-.24a1,1,0,0,1,1.245-1.209l.291.131-.1-.3a1.886,1.886,0,0,1-.137-1.061c.074-.3.466-.561.708-.407l.556.351-.365-.551a1.186,1.186,0,0,1,1.373-1.772l.136.047.046-.138.326-.972-.079.086a1.621,1.621,0,0,1,1.708.163c.418.367.342,1.266-.2,1.418l.095.275a.145.145,0,0,1,.193.06.725.725,0,0,1,.115.318,1.609,1.609,0,0,1-.091.755l-.422,1.612.274.1a1.325,1.325,0,0,1,1.467-.727l.133.038.046-.129a.99.99,0,0,1,1.329-.5l.206.114.011-.232a.778.778,0,0,1,1.365-.278l.328.669-.048-.738c-.014-.2.279-.354.554-.427a3.46,3.46,0,0,1,.884-.154.819.819,0,0,1,.708.311.51.51,0,0,1,.016.667l.214.207c.145-.19.5-.138.7.052a.828.828,0,0,1,.183.809c-.114.624-.662,1.146-.762,1.918l-.095.733.375-.643c.281-.484.973-.628,1.56-.84a4.007,4.007,0,0,1,1.831-.239l.175.028v-.17c0-.226.326-.389.624-.44a5.477,5.477,0,0,1,2.941.309,2.246,2.246,0,0,1,.82.5.65.65,0,0,1,.169.775,7.653,7.653,0,0,1-.583.818l-.627.828-.828,1.092-.2.264.331-.023a6.8,6.8,0,0,1,4.041,1.025l.027.017.03,0a13.329,13.329,0,0,1,1.731.061.8.8,0,0,1,.472.5c.08.231.036.458-.149.517l-.454.145.464.139a.929.929,0,0,1,.591.595.818.818,0,0,1-.14.779l-.019.025-.007.031a1.574,1.574,0,0,1-.6.89l-.038.029-.014.046a1.184,1.184,0,0,1-.77.8l-.436.122.425.161a4.543,4.543,0,0,1,1.869,1.144,1.917,1.917,0,0,1,.478,1.869l-.013.035.006.038a.968.968,0,0,1-.17.721l-.087.109.1.093a.8.8,0,0,1,.26.46l.019.125h.129a2.394,2.394,0,0,1,1.637.66,2.247,2.247,0,0,1,.707,1.582,2.2,2.2,0,0,1-.552,1.587,1.369,1.369,0,0,1-.72.352.534.534,0,0,1-.6-.263l-.238-.522-.04.573a1.794,1.794,0,0,1-.909,1.408l-.191.1.168.139a1.735,1.735,0,0,1,.014,2.535l-.207.165.255.083a1.732,1.732,0,0,1,1.082,1.416,1.708,1.708,0,0,1-.537,1.607l-.115.091.1.112a1.387,1.387,0,1,1-2.117,1.792l-.21-.254-.036.328a3.042,3.042,0,0,1-.546,1.7.981.981,0,0,1-1.388.154l-.266-.321.024.419a1.866,1.866,0,0,1-.768,1.533,1.843,1.843,0,0,1-1.578.371l-.268-.073.107.256A1.224,1.224,0,0,1,288.3,176.5l-.055-.1-.106.04-3.293,1.236a8.729,8.729,0,0,1-3.276.76,6.206,6.206,0,0,1-1.628-.229,5.949,5.949,0,0,0-.822-.221,1.243,1.243,0,0,0-.865.223,8.222,8.222,0,0,1-1.349.9,5.625,5.625,0,0,1-1.5.481,5.47,5.47,0,0,1-3.032-.319,3,3,0,0,0-.763-.249,1.775,1.775,0,0,0-.8.114,12.143,12.143,0,0,1-1.435.457,10.084,10.084,0,0,1-1.452.244,3.425,3.425,0,0,1-1.4-.112,1.239,1.239,0,0,1-.88-.907.885.885,0,0,1,.437-1.064l.092-.033-.024-.094a1.841,1.841,0,0,0-.6-.991,1.154,1.154,0,0,0-1.123-.2.817.817,0,0,0-.575.931.754.754,0,0,0,.848.625l-.107-.155a1.142,1.142,0,0,1-1.219.388,1.3,1.3,0,0,1-.974-.832,1.828,1.828,0,0,1,1.113-2.117l.112-.044-.072-.1a4.293,4.293,0,0,1-.8-1.916l-.056-.383-.115.37a1.479,1.479,0,0,1-1.785.935l-.087-.03-.02.092a2.83,2.83,0,0,1-.8,1.5,1.692,1.692,0,0,1-1.494.431,1.128,1.128,0,0,1-.963-1.005,1.03,1.03,0,0,1,.668-1.1l.133-.034-.109-.087a1.323,1.323,0,0,1,.4-2.2l.075-.02-.04-.069a2.109,2.109,0,0,1,.386-2.54l-.074-.068a1.092,1.092,0,0,1-1.655,0l-.057-.08-.018.1a1.053,1.053,0,0,1-.635.737,2.3,2.3,0,0,1-.874.186,2.714,2.714,0,0,1-1.352-.3,1.238,1.238,0,0,1-.542-.627c-.068-.178-.077-.276-.086-.274",
    transform: "translate(-82.169 -45.034)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38621",
    "data-name": "Path 38621",
    d: "M297.28,188.1,289.271,165c-1.9-6.289-7.148-10.425-13.382-8.349l-.565.225a11.748,11.748,0,0,0-6.871,14.377c1.679,5.441,3.6,11.43,4.766,14.244,2.41,5.827,8.63,4.4,8.63,4.4s.5,1.373,1.113,3.119c0,0,.995,5.861,5.578,4.458s8.742-9.37,8.742-9.37",
    transform: "translate(-87.643 -51.065)",
    fill: "#c78976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38622",
    "data-name": "Path 38622",
    d: "M288.564,203.762a15.23,15.23,0,0,0,6.724-5.3s-.022,5.183-6.075,6.988Z",
    transform: "translate(-94.393 -64.921)",
    fill: "#8b5d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38623",
    "data-name": "Path 38623",
    d: "M273.476,184.084a.9.9,0,0,0,1.144.522.862.862,0,0,0,.561-1.1.9.9,0,0,0-1.143-.523.862.862,0,0,0-.562,1.1",
    transform: "translate(-89.442 -59.84)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38624",
    "data-name": "Path 38624",
    d: "M271.935,180.66c.147.067.594-.654,1.494-1.011s1.74-.17,1.794-.319c.029-.068-.156-.223-.527-.318a2.468,2.468,0,0,0-1.489.12,2.373,2.373,0,0,0-1.135.941c-.193.323-.207.557-.137.586",
    transform: "translate(-88.941 -58.537)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38625",
    "data-name": "Path 38625",
    d: "M285.935,180.094a.9.9,0,0,0,1.143.521.86.86,0,0,0,.561-1.1.9.9,0,0,0-1.143-.523.862.862,0,0,0-.562,1.1",
    transform: "translate(-93.517 -58.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38626",
    "data-name": "Path 38626",
    d: "M285.251,175.973c.148.067.595-.654,1.5-1.011s1.739-.17,1.793-.319c.028-.068-.155-.223-.527-.317a2.466,2.466,0,0,0-1.49.12,2.377,2.377,0,0,0-1.135.941c-.191.323-.207.558-.137.586",
    transform: "translate(-93.297 -57.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38627",
    "data-name": "Path 38627",
    d: "M283.253,185.271a6.441,6.441,0,0,0-1.566.319c-.24.068-.475.109-.577-.032a1.26,1.26,0,0,1-.118-.742q-.009-.964-.019-2.021a32.333,32.333,0,0,0-.3-5.186,32.477,32.477,0,0,0-.118,5.2c.018.705.035,1.377.051,2.02a1.436,1.436,0,0,0,.241.949.619.619,0,0,0,.512.185,1.663,1.663,0,0,0,.412-.1,6.294,6.294,0,0,0,1.482-.589",
    transform: "translate(-91.767 -58.098)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38628",
    "data-name": "Path 38628",
    d: "M283.138,171.612c.186.21,1.039-.263,2.146-.555,1.1-.314,2.077-.343,2.13-.618.021-.13-.219-.3-.658-.4a3.853,3.853,0,0,0-3.257.894c-.326.31-.445.58-.361.681",
    transform: "translate(-92.61 -55.598)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38629",
    "data-name": "Path 38629",
    d: "M270.665,175.961c.237.147.782-.3,1.53-.591.738-.316,1.441-.38,1.507-.65.025-.129-.152-.3-.5-.389a2.374,2.374,0,0,0-2.446,1c-.186.31-.194.555-.087.629",
    transform: "translate(-88.515 -57.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38630",
    "data-name": "Path 38630",
    d: "M284.53,192.132a4.079,4.079,0,0,0,.826.816,1.373,1.373,0,0,0,1.105.232,1.234,1.234,0,0,0,.812-.867,1.969,1.969,0,0,0-.1-1.217c-.133-.35-.436-.72-.8-.645a.93.93,0,0,0-.4.236l-1.606,1.365",
    transform: "translate(-93.022 -62.296)",
    fill: "#8b5d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38631",
    "data-name": "Path 38631",
    d: "M285.644,193.3a2.824,2.824,0,0,0,.949-.449,1.49,1.49,0,0,0,.523-.927,1.567,1.567,0,0,0-.377-1.221,1.426,1.426,0,0,0-.253-.224c-.1-.052-.084-.054-.161-.016s-.172.143-.258.215l-.263.225c-.344.292-.657.551-.923.765a3.581,3.581,0,0,1-.909.638c-.032-.037.255-.348.745-.823.246-.237.542-.515.874-.821l.256-.234a3.551,3.551,0,0,1,.293-.252.455.455,0,0,1,.277-.083.539.539,0,0,1,.258.094,1.671,1.671,0,0,1,.324.282,1.829,1.829,0,0,1,.434,1.5,1.669,1.669,0,0,1-.69,1.072,1.574,1.574,0,0,1-.793.3c-.2.012-.307-.022-.307-.043",
    transform: "translate(-92.89 -62.182)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38632",
    "data-name": "Path 38632",
    d: "M263.5,166.317a7.083,7.083,0,0,1-.209-.932,2.868,2.868,0,0,1,.359-1.4,9.712,9.712,0,0,1,2.717-4.042c.777-.556,1.706-.818,2.487-1.367a16.022,16.022,0,0,0,1.35-1.176,13.784,13.784,0,0,1,6.528-2.93,11.339,11.339,0,0,1,4.028-.219,13.744,13.744,0,0,1,4.336,1.683,20.967,20.967,0,0,1,5.8,4.379,10.261,10.261,0,0,1,2.612,5.239c.273,1.976-.382,4.1-1.853,4.951l-.834-.533-1.3-.767c.314.384.157.408-.129.759a.8.8,0,0,1-1.186.015c-.177.478-.966.273-1.023-.267-.3.308-.92-.04-.937-.529-.373.285-.822-.322-1.174-.712a7.7,7.7,0,0,0-.633-.566,4.9,4.9,0,0,1-1.429-2.325,4.8,4.8,0,0,1-1.519-2.242l-.692-1.608-.424-.3a.946.946,0,0,1-.347,1.042,2.021,2.021,0,0,1-1.016.281l-1.052.1-.568.363a2.63,2.63,0,0,1,.293,1.677,1.632,1.632,0,0,1-.31,1.075.491.491,0,0,1-.8-.311.544.544,0,0,1-.845.11,1.788,1.788,0,0,1-.527-.961,4.565,4.565,0,0,1,.088-2.651l-1.252,2.131a.846.846,0,0,1-.348.384.476.476,0,0,1-.338.648,1.234,1.234,0,0,1-.768-.245c-.552-.319-1.22-.94-.991-1.55-.208.02-.406-.283-.328-.5l-1.524,2.073c.162-.172.469.069.5.336a1.087,1.087,0,0,1-.238.7,1.605,1.605,0,0,1,.5.865c.259-.421.963.01,1,.552a1.159,1.159,0,0,1-.8,1.116.8.8,0,0,1-1.043-.314c-.4.218-.994-.252-.984-.785-.25.3-.689-.18-.831-.6a6.36,6.36,0,0,1-.331-2.278.118.118,0,0,1-.145.092.133.133,0,0,1-.066-.07q-.147,1.414-.294,2.827a6.568,6.568,0,0,0,.055,2.425c.089.324.182.777-.08.885a.411.411,0,0,1-.229.007,4.213,4.213,0,0,1-2.377-1.538,3.176,3.176,0,0,1-.55-.869,13.539,13.539,0,0,1-.327-2.132",
    transform: "translate(-86.125 -50.425)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38633",
    "data-name": "Path 38633",
    d: "M275.314,163.894a.974.974,0,0,1-.392-.408.687.687,0,0,1,.005-.612.732.732,0,0,1,.662-.392l.171.007-.11-.131a.768.768,0,0,1-.044-.886.752.752,0,0,1,.938-.237l.09-.151a.332.332,0,0,1-.078-.079.434.434,0,0,1-.042-.369.5.5,0,0,1,.248-.281.837.837,0,0,1,.379-.092,1.046,1.046,0,0,0,.447-.029c.169-.084.209-.24.284-.326a1.432,1.432,0,0,1,.238-.263,1.648,1.648,0,0,1,.56-.312,1.71,1.71,0,0,1,.932-.043c.219.054.33.118.338.1a.774.774,0,0,0-.32-.17,1.66,1.66,0,0,0-.988-.01,1.76,1.76,0,0,0-.618.319,1.551,1.551,0,0,0-.268.285c-.086.109-.138.235-.226.269a1.026,1.026,0,0,1-.379.008,1,1,0,0,0-.461.108.675.675,0,0,0-.334.38.608.608,0,0,0,.064.523.513.513,0,0,0,.127.126l.089-.151a.894.894,0,0,0-1.091,1.377l.061-.124a.861.861,0,0,0-.778.487.8.8,0,0,0,.345,1.027c.093.048.148.053.151.048",
    transform: "translate(-89.873 -52.058)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38634",
    "data-name": "Path 38634",
    d: "M269.471,166.033a1.19,1.19,0,0,1-.454-.376.875.875,0,0,1-.146-.644.913.913,0,0,1,.519-.669l.116-.051-.108-.068a1.088,1.088,0,0,1-.551-.831.581.581,0,0,1,.226-.475.463.463,0,0,1,.515-.079l.624.369-.523-.5a.9.9,0,0,1-.258-.716.83.83,0,0,1,.434-.663.886.886,0,0,1,.576-.107l.223.039-.14-.18a.573.573,0,0,1,.278-.8,1.486,1.486,0,0,1,.951-.036l.186.04-.1-.159a.642.642,0,0,1,.029-.656,1.187,1.187,0,0,1,.5-.422,3.026,3.026,0,0,1,1.081-.287,4.874,4.874,0,0,1,1,.062.816.816,0,0,0-.252-.085,2.841,2.841,0,0,0-.748-.071,3,3,0,0,0-1.134.262,1.307,1.307,0,0,0-.566.464.79.79,0,0,0-.039.817l.085-.119a1.622,1.622,0,0,0-1.059.038.819.819,0,0,0-.405.436.626.626,0,0,0,.063.622l.084-.141a1.053,1.053,0,0,0-.692.125,1.006,1.006,0,0,0-.522.8,1.072,1.072,0,0,0,.316.854l.1-.134a.625.625,0,0,0-.7.1.742.742,0,0,0-.278.606,1.218,1.218,0,0,0,.636.94l.008-.119a1.018,1.018,0,0,0-.571.775.938.938,0,0,0,.191.7.926.926,0,0,0,.36.289.34.34,0,0,0,.155.042",
    transform: "translate(-87.892 -51.902)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38635",
    "data-name": "Path 38635",
    d: "M256.772,170.872a.652.652,0,0,1,.083-.523.839.839,0,0,1,.5-.362,2.5,2.5,0,0,1,.854-.043l.1.007-.042-.1a.754.754,0,0,1,.384-.876,2.186,2.186,0,0,1,1.245-.154l.579.043-.545-.2a.62.62,0,0,1-.2-.869,1.409,1.409,0,0,1,.973-.551l.052-.009.339-.066-.329-.106a.665.665,0,0,1-.221-1.03,1.006,1.006,0,0,1,1.106-.208l.423.172-.339-.307a1.508,1.508,0,0,1-.423-1.473,1.408,1.408,0,0,1,.809-.921,1.6,1.6,0,0,1,.82-.127c.2.024.3.064.3.053s-.022-.018-.07-.038a1.055,1.055,0,0,0-.222-.065,1.555,1.555,0,0,0-.866.088,1.5,1.5,0,0,0-.9.975,1.642,1.642,0,0,0,.445,1.629l.086-.135a1.168,1.168,0,0,0-1.3.244.849.849,0,0,0-.186.718.746.746,0,0,0,.485.595l.01-.171-.055.01a1.559,1.559,0,0,0-1.089.637.892.892,0,0,0-.093.627.649.649,0,0,0,.387.483l.035-.16a2.308,2.308,0,0,0-1.333.192.885.885,0,0,0-.423,1.054l.061-.088a2.505,2.505,0,0,0-.891.073.9.9,0,0,0-.529.423.627.627,0,0,0-.08.42.256.256,0,0,0,.056.138",
    transform: "translate(-83.972 -53.35)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38636",
    "data-name": "Path 38636",
    d: "M260.121,159.307a.514.514,0,0,0,.245.016,2.987,2.987,0,0,0,.664-.156,2.028,2.028,0,0,1,.983-.132.624.624,0,0,1,.447.314.451.451,0,0,1-.028.543l.139.049c-.028-.226.2-.441.4-.654a2.939,2.939,0,0,1,.69-.568,1.057,1.057,0,0,1,.837-.109.7.7,0,0,1,.527.521l.034.215.117-.184a1.949,1.949,0,0,1,.968-.773,2.2,2.2,0,0,1,.982-.137,2.805,2.805,0,0,1,.856.252.683.683,0,0,0-.2-.142,1.852,1.852,0,0,0-.648-.21,2.211,2.211,0,0,0-1.041.108,2.061,2.061,0,0,0-1.06.815l.151.03a.865.865,0,0,0-.639-.661,1.229,1.229,0,0,0-.971.12,3.034,3.034,0,0,0-.732.6,3.87,3.87,0,0,0-.3.342.644.644,0,0,0-.14.453l.023.166.117-.117a.607.607,0,0,0,.048-.738.769.769,0,0,0-.555-.375,2.041,2.041,0,0,0-1.042.173,3.871,3.871,0,0,1-.639.2,2.216,2.216,0,0,0-.238.038",
    transform: "translate(-85.089 -51.727)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38637",
    "data-name": "Path 38637",
    d: "M271.143,151.393a1.825,1.825,0,0,1,.46-.067,1.111,1.111,0,0,1,.5.145.96.96,0,0,1,.434.488l.033.09.078-.055a.58.58,0,0,1,.717.168,1.757,1.757,0,0,1,.3.92l.045.345.126-.33.02-.052a.748.748,0,0,1,.51-.408.832.832,0,0,1,.62.08,1.324,1.324,0,0,1,.628.9,2.466,2.466,0,0,1,.023.783,1.368,1.368,0,0,0-.027.295.79.79,0,0,0,.1-.283,2.17,2.17,0,0,0,.032-.818,1.43,1.43,0,0,0-.671-1.016.979.979,0,0,0-1.371.4l-.026.067.172.015a1.87,1.87,0,0,0-.351-1.009.729.729,0,0,0-.928-.178l.112.034a1.072,1.072,0,0,0-.515-.542,1.143,1.143,0,0,0-.557-.124.931.931,0,0,0-.354.081c-.074.038-.109.066-.106.072",
    transform: "translate(-88.694 -49.473)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38638",
    "data-name": "Path 38638",
    d: "M284.3,153.35c0,.009.085-.022.207-.114a1.457,1.457,0,0,0,.4-.508,1.557,1.557,0,0,0,.139-.957.8.8,0,0,1-.022-.492c.062-.146.246-.281.316-.513a.881.881,0,0,0-.548-1.075l.043.121a2.814,2.814,0,0,0,.43-1.21,1.14,1.14,0,0,0-.016-.5c-.021,0-.023.181-.081.48a3.078,3.078,0,0,1-.468,1.136l-.061.09.1.032a.726.726,0,0,1,.427.869c-.044.17-.208.289-.3.5a.919.919,0,0,0,.02.593,1.5,1.5,0,0,1-.094.874,2.222,2.222,0,0,1-.5.674",
    transform: "translate(-92.997 -48.448)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38639",
    "data-name": "Path 38639",
    d: "M288.161,154.82c0,.007.052,0,.147-.021a2.016,2.016,0,0,0,.39-.151,2.345,2.345,0,0,0,1.041-1.069l-.11.03a1.507,1.507,0,0,0,1.144.236,1.553,1.553,0,0,0,.608-.257.953.953,0,0,0,.415-.577,2.039,2.039,0,0,0,0-.262.349.349,0,0,1,.06-.188,1.084,1.084,0,0,1,.339-.285,1.407,1.407,0,0,0,.383-.3.5.5,0,0,0,.119-.485l-.085.1a1.544,1.544,0,0,0,1.036-.274,1.67,1.67,0,0,0,.554-.62,1.376,1.376,0,0,0,.153-.515.453.453,0,0,0-.01-.19,2.216,2.216,0,0,1-.227.66,1.651,1.651,0,0,1-.543.555,1.434,1.434,0,0,1-.944.227l-.127-.015.042.121a.341.341,0,0,1-.1.326,1.271,1.271,0,0,1-.345.264,1.214,1.214,0,0,0-.395.335.522.522,0,0,0-.09.28,2.34,2.34,0,0,1,0,.242.8.8,0,0,1-.343.46,1.416,1.416,0,0,1-.537.232,1.373,1.373,0,0,1-1.026-.192l-.073-.051-.036.08a2.377,2.377,0,0,1-.948,1.056c-.3.179-.5.227-.5.247",
    transform: "translate(-94.261 -49.065)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38640",
    "data-name": "Path 38640",
    d: "M304.7,157.615s0-.021,0-.064a1,1,0,0,0-.023-.184,1.853,1.853,0,0,0-.275-.647,4.155,4.155,0,0,0-.729-.816,3.878,3.878,0,0,0-.53-.425,1.026,1.026,0,0,0-.359-.141.466.466,0,0,0-.414.121l.127.038a1.169,1.169,0,0,0-2.113-.446l.155.028a.8.8,0,0,0-.5-.542.775.775,0,0,0-.746.121.8.8,0,0,0-.259.347l.169.013a.5.5,0,0,0-.293-.345.686.686,0,0,0-.428-.048,1.59,1.59,0,0,0-.668.394l.112,0a1.252,1.252,0,0,0-.879-.3,1.759,1.759,0,0,0-.827.24,4.447,4.447,0,0,0-1.089,1l.111.05a.311.311,0,0,0-.119-.284.535.535,0,0,0-.255-.1.915.915,0,0,0-.47.062,2.585,2.585,0,0,0-.613.4,2.334,2.334,0,0,0-.315.335.486.486,0,0,0-.086.136c.014.011.14-.172.446-.417a2.644,2.644,0,0,1,.608-.359.8.8,0,0,1,.413-.042c.145.02.29.11.265.252l-.038.213.149-.162a4.45,4.45,0,0,1,1.069-.953,1.612,1.612,0,0,1,.756-.211,1.1,1.1,0,0,1,.761.261l.055.051.058-.048a1.451,1.451,0,0,1,.593-.354.429.429,0,0,1,.513.259l.06.3.109-.293a.617.617,0,0,1,.2-.268.6.6,0,0,1,.577-.1.638.638,0,0,1,.391.42l.047.184.108-.157a1.032,1.032,0,0,1,1.089-.406,1.044,1.044,0,0,1,.735.782l.028.143.1-.1c.149-.159.412-.076.6.033a3.912,3.912,0,0,1,.519.4,4.351,4.351,0,0,1,.737.773,2.343,2.343,0,0,1,.367.846",
    transform: "translate(-95.973 -50.535)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38641",
    "data-name": "Path 38641",
    d: "M306.034,164.688a.439.439,0,0,0,.054-.132,2.71,2.71,0,0,0,.1-.4,1.25,1.25,0,0,0-.045-.657.907.907,0,0,0-.239-.349.66.66,0,0,0-.453-.177l.062.081a.821.821,0,0,0-1.193-.965l.112.1a.66.66,0,0,0-.242-.743.979.979,0,0,0-.818-.127,3.693,3.693,0,0,1-.378.108.333.333,0,0,1-.292-.135,1.442,1.442,0,0,0-.324-.3.752.752,0,0,0-.462-.1,4.35,4.35,0,0,0-.906.239,1.012,1.012,0,0,1-.789,0,3.911,3.911,0,0,1-.326-.255.876.876,0,0,0-.418-.164.927.927,0,0,0-.778.272l.13.076a.7.7,0,0,0-.318-.751.986.986,0,0,0-.723-.13,3.141,3.141,0,0,0-1.064.458,3.827,3.827,0,0,0-.584.457.87.87,0,0,0-.175.2,8.9,8.9,0,0,1,.807-.575,3.19,3.19,0,0,1,1.036-.41.861.861,0,0,1,.624.12.555.555,0,0,1,.251.589l-.1.317.232-.241a.769.769,0,0,1,.645-.215.715.715,0,0,1,.338.136,3.657,3.657,0,0,0,.34.269.918.918,0,0,0,.466.106,2.008,2.008,0,0,0,.458-.087,4.4,4.4,0,0,1,.867-.231.588.588,0,0,1,.361.079,1.323,1.323,0,0,1,.289.272.514.514,0,0,0,.437.185,3.334,3.334,0,0,0,.4-.115.816.816,0,0,1,.677.093.5.5,0,0,1,.2.554l-.083.212.2-.115a.7.7,0,0,1,.8.085.712.712,0,0,1,.191.705l-.026.085.087,0a.672.672,0,0,1,.6.44,1.233,1.233,0,0,1,.068.611c-.044.345-.1.534-.086.538",
    transform: "translate(-96.813 -52.389)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38642",
    "data-name": "Path 38642",
    d: "M314.344,176.34s.06-.023.149-.1a1.2,1.2,0,0,0,.3-.416,1.257,1.257,0,0,0,.077-.8,1.336,1.336,0,0,0-.62-.842l.034.088a2.432,2.432,0,0,0,.2-.968.993.993,0,0,0-.2-.529.723.723,0,0,0-.522-.3l.06.144a1.02,1.02,0,0,0,.166-1,1.138,1.138,0,0,0-.334-.5.968.968,0,0,0-.539-.222c-.181-.024-.278-.078-.33-.24a1.4,1.4,0,0,0-.257-.462,1.778,1.778,0,0,0-.825-.491c-.275-.1-.53-.192-.768-.271a2.927,2.927,0,0,0-1.172-.185,1.36,1.36,0,0,0-.318.065c-.07.027-.1.043-.1.049s.151-.041.425-.045a3.142,3.142,0,0,1,1.128.234l.757.29a1.659,1.659,0,0,1,.752.459,1.246,1.246,0,0,1,.224.418.506.506,0,0,0,.175.251.684.684,0,0,0,.284.1.91.91,0,0,1,.6,1.441l-.118.132.178.012a.7.7,0,0,1,.564.671,2.347,2.347,0,0,1-.172.907l-.019.058.052.03a1.224,1.224,0,0,1,.577.743,1.2,1.2,0,0,1-.04.737,1.745,1.745,0,0,1-.367.548",
    transform: "translate(-101.189 -55.359)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38643",
    "data-name": "Path 38643",
    d: "M288.121,164.723a1.314,1.314,0,0,0,.442-.345,1.474,1.474,0,0,0,.34-.525.972.972,0,0,0-.048-.782.742.742,0,0,0-.121-.156v.127a.841.841,0,0,0,.254-.679.77.77,0,0,0-.267-.517c-.263-.216-.489-.18-.483-.164a1.484,1.484,0,0,1,.4.25.674.674,0,0,1,.192.441.7.7,0,0,1-.216.539l-.064.059.063.068a.6.6,0,0,1,.089.119.843.843,0,0,1,.047.644,1.538,1.538,0,0,1-.279.493c-.213.258-.368.407-.349.427",
    transform: "translate(-94.248 -52.884)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38644",
    "data-name": "Path 38644",
    d: "M281.3,163.379a1.035,1.035,0,0,1-.3-.583.729.729,0,0,1,.244-.645.789.789,0,0,1,.843-.109l.135.069-.013-.151a1.424,1.424,0,0,1,.048-.554.665.665,0,0,1,.335-.424c.259-.115.634.047.625.292l.169-.014a1.341,1.341,0,0,1,.219-.976,1.306,1.306,0,0,1,.643-.488,2.016,2.016,0,0,1,.745-.078c0-.008-.064-.041-.2-.063a1.336,1.336,0,0,0-.579.038,1.38,1.38,0,0,0-.73.505,1.469,1.469,0,0,0-.267,1.09l.169-.014a.494.494,0,0,0-.31-.442.7.7,0,0,0-.553-.013.826.826,0,0,0-.432.536,1.579,1.579,0,0,0-.047.622l.12-.083a.928.928,0,0,0-1.012.151.831.831,0,0,0-.253.765.852.852,0,0,0,.242.468c.091.084.155.107.158.1",
    transform: "translate(-91.881 -52.221)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38645",
    "data-name": "Path 38645",
    d: "M301.456,175.6c.083-.083,3.549-2.8,5.018,1.258s-2.9,4.694-2.953,4.58-2.066-5.839-2.066-5.839",
    transform: "translate(-98.61 -57.124)",
    fill: "#c78976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38646",
    "data-name": "Path 38646",
    d: "M305.17,180.077c.013-.019.089.024.228.035a.747.747,0,0,0,.532-.18,1.86,1.86,0,0,0,.24-1.861,2.476,2.476,0,0,0-.565-.939.868.868,0,0,0-.727-.35.382.382,0,0,0-.346.345c-.013.133.042.2.023.219s-.112-.036-.14-.216a.482.482,0,0,1,.067-.311.568.568,0,0,1,.353-.245,1.054,1.054,0,0,1,.965.361,2.55,2.55,0,0,1,.655,1.041,1.951,1.951,0,0,1-.4,2.125.806.806,0,0,1-.685.126c-.161-.054-.216-.137-.2-.15",
    transform: "translate(-99.577 -57.752)",
    fill: "#8b5d54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170207",
    "data-name": "Group 170207",
    transform: "translate(193.429 160.539)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170206",
    "data-name": "Group 170206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170205",
    "data-name": "Group 170205",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38647",
    "data-name": "Path 38647",
    d: "M288.085,258.544s8.085.964,13.482-2.594,12.125-17.368,12.125-17.368-13.493,15.579-26.23,17.585Z",
    transform: "translate(-287.462 -238.582)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38648",
    "data-name": "Path 38648",
    d: "M289.129,217.306c-4.6,5.983-13.259,17.28-13.259,17.28l-32.048,4.7,1.673,10.622,31.844-1.827a18.571,18.571,0,0,0,12.185-6.125c3.893-4.358,9.2-10.4,12.512-14.593a8.182,8.182,0,1,0-12.906-10.059",
    transform: "translate(-79.757 -70.039)",
    fill: "#76c8ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38649",
    "data-name": "Path 38649",
    d: "M327.206,359.957c-.095.021-2.159-9.418-4.611-21.077s-4.363-21.131-4.268-21.151,2.159,9.416,4.611,21.079,4.363,21.129,4.268,21.149",
    transform: "translate(-104.128 -103.933)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38650",
    "data-name": "Path 38650",
    d: "M358.616,369.08c.07.067-.406.677-1.063,1.363s-1.245,1.187-1.315,1.121.405-.677,1.062-1.363,1.245-1.187,1.316-1.12",
    transform: "translate(-116.528 -120.729)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38651",
    "data-name": "Path 38651",
    d: "M294.179,209.852s-.1.153-.316.437l-.957,1.248-3.682,4.733-13.338,17.013-.036.045-.057.009-32.044,4.731.147-.2,1,6.125q.381,2.345.754,4.646l-.183-.147,33.934-2.11-.015,0a18.508,18.508,0,0,0,5.843-2.429,19.141,19.141,0,0,0,4.335-3.72l6.125-7.053,3.938-4.507,1.042-1.177c.238-.264.368-.393.368-.393s-.108.148-.335.422l-1.01,1.2-3.879,4.559-6.076,7.1a19.312,19.312,0,0,1-10.3,6.279h0l-.011,0-33.93,2.171-.158.01-.026-.157q-.372-2.3-.754-4.646c-.34-2.1-.678-4.173-.994-6.125l-.029-.175.176-.026,32.053-4.672-.092.054c5.591-7.049,10.207-12.868,13.434-16.937l3.744-4.683.99-1.222c.225-.275.351-.409.351-.409",
    transform: "translate(-79.66 -68.645)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38652",
    "data-name": "Path 38652",
    d: "M317.061,263.642a3.534,3.534,0,0,1-.4.7c-.27.444-.7,1.061-1.266,1.8a30.935,30.935,0,0,1-11.223,9.039c-.842.394-1.537.682-2.028.852a3.535,3.535,0,0,1-.772.238c-.022-.057,1.046-.474,2.69-1.313a34.8,34.8,0,0,0,11.139-8.97c1.17-1.427,1.805-2.382,1.856-2.348",
    transform: "translate(-98.584 -86.24)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38653",
    "data-name": "Path 38653",
    d: "M322.786,270.715c.048.084-2.8,1.795-6.366,3.82s-6.493,3.6-6.541,3.516,2.8-1.795,6.367-3.82,6.492-3.6,6.54-3.515",
    transform: "translate(-101.365 -88.554)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38654",
    "data-name": "Path 38654",
    d: "M279.2,234.16a4.035,4.035,0,0,1-.224-.678q-.225-.772-.545-1.866c-.467-1.665-1.068-3.807-1.733-6.175-.664-2.417-1.251-4.609-1.659-6.2q-.272-1.107-.466-1.889a2.844,2.844,0,0,1-.126-.7,2.815,2.815,0,0,1,.257.668c.143.437.339,1.072.574,1.859.47,1.573,1.094,3.755,1.759,6.172s1.242,4.609,1.634,6.2a13.726,13.726,0,0,1,.53,2.609",
    transform: "translate(-89.774 -70.868)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170210",
    "data-name": "Group 170210",
    transform: "translate(205.962 184.336)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170209",
    "data-name": "Group 170209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170208",
    "data-name": "Group 170208",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38655",
    "data-name": "Path 38655",
    d: "M306.087,281.751c3.157-.332,6.374-.414,9.317-1.6a12.384,12.384,0,0,0,6.911-6.2,104.213,104.213,0,0,1-16.228,7.8",
    transform: "translate(-306.087 -273.948)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38656",
    "data-name": "Path 38656",
    d: "M221.037,271.571c-.067.073-.657.648-1.208,1.184a4.942,4.942,0,0,0-1.334,2.218c-.26.948-.433,1.692-.474,1.748l-1.309,4.168,4.844,3.549.777-3.5a11.558,11.558,0,0,0,3.086-1.828,5.49,5.49,0,0,0,1.83-2.385,1.183,1.183,0,0,0-.133-1s-.063-1.913-.753-1.971a2.588,2.588,0,0,0,.136-1.535c-.446-.96-1.789-.886-1.789-.886a.449.449,0,0,0-.044-.753.636.636,0,0,0-.879.152l-2.708,2.406Z",
    transform: "translate(-70.889 -88.47)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38657",
    "data-name": "Path 38657",
    d: "M164.927,288.176a7.487,7.487,0,0,0,1.4,9.659c6.389,5.573,23.685,15.265,26.282,14.833,3.751-.624,13.558-22.46,13.558-22.46l-7.3-6.014-9.128,14.794s-7.532-7.11-13.421-11.774c-3.582-2.836-8.939-2.9-11.389.962",
    transform: "translate(-53.567 -92.964)",
    fill: "#65a743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38658",
    "data-name": "Path 38658",
    d: "M177.208,286.788a1.891,1.891,0,0,1,.258.2l.731.615,2.777,2.386,10.1,8.776-.2.03,9.1-14.811.1-.163.148.122,7.3,6.008.1.085-.055.121c-.775,1.713-1.622,3.508-2.5,5.319-1.544,3.17-3.114,6.236-4.759,9.13-.824,1.446-1.667,2.849-2.562,4.181-.455.661-.91,1.313-1.414,1.921a8.361,8.361,0,0,1-1.682,1.653,1.786,1.786,0,0,1-1.165.346,5.7,5.7,0,0,1-1.128-.248c-.721-.223-1.406-.5-2.075-.778-1.334-.573-2.6-1.191-3.811-1.808-2.421-1.239-4.625-2.486-6.615-3.66-3.979-2.352-7.086-4.441-9.167-5.974-1.04-.767-1.826-1.392-2.345-1.833-.262-.217-.451-.394-.582-.51a1.454,1.454,0,0,1-.19-.184,1.429,1.429,0,0,1,.213.157l.6.483c.532.422,1.33,1.027,2.38,1.776,2.1,1.5,5.224,3.549,9.212,5.871,1.994,1.158,4.2,2.39,6.622,3.614,1.21.609,2.473,1.22,3.8,1.783.664.276,1.345.546,2.046.76a5.5,5.5,0,0,0,1.062.232,1.468,1.468,0,0,0,.963-.3,8.132,8.132,0,0,0,1.6-1.592c.493-.6.942-1.245,1.392-1.9.885-1.323,1.722-2.721,2.541-4.163,1.636-2.886,3.2-5.948,4.743-9.113.879-1.808,1.726-3.6,2.5-5.309l.048.205-7.292-6.018.248-.042c-3.413,5.51-6.532,10.543-9.156,14.776l-.083.136-.12-.106-10.02-8.863-2.73-2.441-.705-.644a2.018,2.018,0,0,1-.232-.23",
    transform: "translate(-54.814 -92.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38659",
    "data-name": "Path 38659",
    d: "M168.877,108.867a2.563,2.563,0,0,1-.315.639,4.258,4.258,0,0,0,.114,4.469l1.531,2.343.186,3.6,7.82,1.875-.367-6.355a13.754,13.754,0,0,0,1.307-4.492c.015-1.813-.467-3.74-1.061-3.821l-.776-.106a2.686,2.686,0,0,0-1.553-1.235s-.471-2.344-1.281-2.547-1.528.629-1.528.629-1-1.914-1.851-1.788a2.031,2.031,0,0,0-1.735,2l-.516,4.952Z",
    transform: "translate(-54.95 -33.391)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38660",
    "data-name": "Path 38660",
    d: "M140.312,1.39a1.983,1.983,0,0,0-3.784,1.186l94.294,300.4,4.13.172Z",
    transform: "translate(-44.63 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38661",
    "data-name": "Path 38661",
    d: "M98.526,7.979S73.466,25.063,54.079,26.606,12.762,29.627,1.231,42.571c0,0,42.6,6.686,45,12.347,0,0-25.463,20.226-29.323,31.838,0,0,18.321-6.492,22.1-8.093,12.555-5.319,36.969-2.949,46.265-6.3,10.3-3.717,20.047-14.167,28.523-15.793Z",
    transform: "translate(-0.403 -2.61)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170213",
    "data-name": "Group 170213",
    transform: "translate(57.593 27.162)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170212",
    "data-name": "Group 170212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170211",
    "data-name": "Group 170211",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38662",
    "data-name": "Path 38662",
    d: "M97.116,40.367l7.919,7.964,11.05-2.009-5.127,9.992,5.325,9.889L105.2,64.415l-7.759,8.12-1.726-11.1-10.12-4.87L95.612,51.5Z",
    transform: "translate(-85.591 -40.367)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38663",
    "data-name": "Path 38663",
    d: "M120.105,33.922a2.408,2.408,0,0,1-.148.458c-.124.328-.287.756-.488,1.29-.211.561-.481,1.243-.835,2.017s-.719,1.673-1.21,2.627c-.47.964-.991,2.016-1.614,3.113-.586,1.117-1.3,2.262-2.028,3.477a80.261,80.261,0,0,1-5.356,7.506,80.083,80.083,0,0,1-6.257,6.777c-1.04.964-2.017,1.893-2.99,2.695-.947.832-1.871,1.558-2.718,2.214-.833.675-1.637,1.221-2.325,1.721s-1.3.908-1.8,1.229l-1.163.742a2.442,2.442,0,0,1-.419.238,2.527,2.527,0,0,1,.38-.3l1.124-.8c.494-.337,1.093-.756,1.766-1.274s1.466-1.071,2.286-1.757c.835-.666,1.747-1.4,2.682-2.239.962-.809,1.927-1.742,2.956-2.708a84.166,84.166,0,0,0,6.209-6.765,84.186,84.186,0,0,0,5.355-7.457c.735-1.2,1.452-2.34,2.048-3.446.63-1.087,1.163-2.129,1.645-3.083.5-.943.888-1.83,1.253-2.6s.658-1.437.888-1.989l.549-1.264a2.483,2.483,0,0,1,.214-.433",
    transform: "translate(-29.685 -11.096)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38664",
    "data-name": "Path 38664",
    d: "M150.151,54.578a1.669,1.669,0,0,1-.148-.366c-.095-.281-.214-.635-.36-1.069l-1.258-3.952c-1.046-3.342-2.466-7.966-4-13.084s-2.889-9.764-3.829-13.138c-.47-1.687-.836-3.056-1.066-4.009-.116-.476-.2-.848-.242-1.1a1.989,1.989,0,0,1-.035-.294c0-.022,0-.087.04-.067a.045.045,0,0,1,.011.026c-.05-.067-.009.068.054.32.08.285.18.643.3,1.083.29.984.688,2.331,1.173,3.975l3.926,13.106c1.517,5.1,2.889,9.716,3.9,13.113.476,1.648.866,3,1.151,3.984l.3,1.088a1.7,1.7,0,0,1,.081.386",
    transform: "translate(-45.539 -5.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170216",
    "data-name": "Group 170216",
    transform: "translate(95.827 18.453)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170215",
    "data-name": "Group 170215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170214",
    "data-name": "Group 170214",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38665",
    "data-name": "Path 38665",
    d: "M142.428,27.436c.282,6.154.569,12.347,1.945,18.352s3.913,11.874,8.17,16.327q-5.774-17.128-10.132-34.691",
    transform: "translate(-142.412 -27.423)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38666",
    "data-name": "Path 38666",
    d: "M216.8,246.987c.185.015,3.2.009,5,0a3.425,3.425,0,0,1,2.3.875c1.4,1.26,3.807,3.425,3.807,3.425l5.557-.636,1.544,9.187-7.69-.291a24.073,24.073,0,0,1-5.343.921c-2.046-.029-4.208-.622-4.285-1.294s-.1-.879-.1-.879a3.035,3.035,0,0,1-1.355-1.785s-2.634-.591-2.843-1.51.748-1.709.748-1.709-2.124-1.173-1.971-2.133a2.33,2.33,0,0,1,1.08-1.484l4.168-.559Z",
    transform: "translate(-69.401 -80.793)",
    fill: "#c78976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38667",
    "data-name": "Path 38667",
    d: "M190.873,241.493a9.5,9.5,0,0,1,1.3,8.694c-.5,1.4-1.332,2.917-.7,4.257s2.437,1.785,3.016,3.132c.682,1.587-.713,3.294-.783,5.02a3.419,3.419,0,0,0,2.844,3.4,13.339,13.339,0,0,1-7.135,1.038q-.582-1.389-1.164-2.778a2.45,2.45,0,0,1-.947,2.859,5.58,5.58,0,0,1-3.1.861,16.931,16.931,0,0,1-13.688-6.213",
    transform: "translate(-55.777 -78.996)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38668",
    "data-name": "Path 38668",
    d: "M155.386,241.72a34.3,34.3,0,0,0,2.074-2.906c1.172-2.277.733-5.318,2.5-7.176,1.255-1.322,3.239-1.6,5.061-1.659s3.746-.011,5.335-.905c1.165-.655,2.027-1.76,3.19-2.42a8.035,8.035,0,0,1,5.57-.47,11.406,11.406,0,0,1,5.286,2.4,6.261,6.261,0,0,1,2.249,5.182,18.482,18.482,0,0,0-.42,2.824,19.543,19.543,0,0,0,.828,3.027,5.019,5.019,0,0,1-2.786,5.476l-17.476,13.2c-3,.289-9.247-2.74-10.8-5.318s-2.257-8.738-.6-11.256",
    transform: "translate(-50.518 -73.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38669",
    "data-name": "Path 38669",
    d: "M187.13,246.485c.5-3.94-1.173-9.207-5.13-9.536l-12.7.754a2.323,2.323,0,0,0-2.483,1.926l-4.27,29.454-.087,0s1.17,8.766,9.656,7.793c1.683-.193,2.243.521,2.9-1.2l.044-.212c.518-2.176,1.482-6.681,1.482-6.681.476-2.353.661-3.32.658-3.3,0,0,5.131.122,7.4-6.17,1.128-3.129,1.974-8.451,2.525-12.828",
    transform: "translate(-53.145 -77.509)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38670",
    "data-name": "Path 38670",
    d: "M182.242,256.479a.847.847,0,0,1-.962.687.811.811,0,0,1-.715-.914.848.848,0,0,1,.962-.688.811.811,0,0,1,.716.915",
    transform: "translate(-59.062 -83.596)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38671",
    "data-name": "Path 38671",
    d: "M194.927,258.369a.846.846,0,0,1-.962.686.81.81,0,0,1-.715-.913.848.848,0,0,1,.962-.688.811.811,0,0,1,.716.915",
    transform: "translate(-63.212 -84.214)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38672",
    "data-name": "Path 38672",
    d: "M195.349,254.485c-.129.125-.758-.561-1.745-.68-.984-.136-1.773.367-1.865.213-.046-.069.1-.307.443-.535a2.269,2.269,0,0,1,1.511-.343,2.246,2.246,0,0,1,1.369.715c.274.309.349.574.286.629",
    transform: "translate(-62.718 -82.8)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38673",
    "data-name": "Path 38673",
    d: "M181.764,252.338c-.149.107-.749-.637-1.782-.871-1.029-.25-1.914.147-2-.014-.041-.073.133-.287.521-.47a2.565,2.565,0,0,1,1.634-.155,2.5,2.5,0,0,1,1.381.861c.258.334.312.6.241.649",
    transform: "translate(-58.22 -82.027)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38674",
    "data-name": "Path 38674",
    d: "M186.455,259.767a6.026,6.026,0,0,1,1.5.015c.233.02.458.015.526-.133a1.184,1.184,0,0,0-.023-.707q-.165-.891-.345-1.87a30.466,30.466,0,0,1-.651-4.844,30.624,30.624,0,0,1,1.039,4.78q.163.981.314,1.875a1.344,1.344,0,0,1-.052.92.588.588,0,0,1-.44.263,1.6,1.6,0,0,1-.4-.02,5.932,5.932,0,0,1-1.475-.279",
    transform: "translate(-60.992 -82.507)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38675",
    "data-name": "Path 38675",
    d: "M180.364,277.423a16.809,16.809,0,0,1-8.249-3.974s1.259,4.86,7.869,5.489Z",
    transform: "translate(-56.301 -89.449)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38676",
    "data-name": "Path 38676",
    d: "M183.924,266.1a1.642,1.642,0,0,0-1.332-.875,1.5,1.5,0,0,0-1.121.352.948.948,0,0,0-.275,1.053,1.1,1.1,0,0,0,1.117.52,3.439,3.439,0,0,0,1.275-.465,1.007,1.007,0,0,0,.306-.216.3.3,0,0,0,.062-.333",
    transform: "translate(-59.25 -86.758)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38677",
    "data-name": "Path 38677",
    d: "M182.233,263.606c.147.02-.036.992.664,1.84s1.755.939,1.737,1.076c0,.063-.266.145-.706.074a2.466,2.466,0,0,1-1.461-.843,2.149,2.149,0,0,1-.5-1.532c.04-.413.2-.633.26-.615",
    transform: "translate(-59.523 -86.229)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38678",
    "data-name": "Path 38678",
    d: "M182.66,248.109c-.135.227-1.007-.059-2.081-.133-1.074-.095-1.98.051-2.077-.194-.042-.117.149-.318.536-.488a3.624,3.624,0,0,1,3.169.249c.356.229.513.457.454.565",
    transform: "translate(-58.388 -80.811)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38679",
    "data-name": "Path 38679",
    d: "M195.195,250.3c-.219.169-.883-.176-1.729-.348-.84-.2-1.592-.161-1.716-.406-.053-.117.1-.3.449-.432a2.859,2.859,0,0,1,2.776.607c.26.267.318.495.22.579",
    transform: "translate(-62.72 -81.444)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38680",
    "data-name": "Path 38680",
    d: "M166.049,237.728a5.4,5.4,0,0,1,3.124-1.038,60.7,60.7,0,0,1,14.406.225,2.466,2.466,0,0,1-1.616,2.7,11.022,11.022,0,0,1-3.379.53,4.272,4.272,0,0,0-3.069,1.319c-.748.962-.714,2.351-1.413,3.35-1.2,1.718-4.027,1.611-5.22,3.336-.9,1.3-.483,3.067-.686,4.64a5.668,5.668,0,0,1-7.061,4.77l3.5-16.648a5.651,5.651,0,0,1,1.412-3.181",
    transform: "translate(-52.709 -77.319)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38681",
    "data-name": "Path 38681",
    d: "M145.6,248.367c1.073-.539,2.336-.914,2.98-1.928.939-1.476.158-3.721,1.39-4.963,1.123-1.132,3.345-.457,4.422-1.633.842-.918.465-2.035.929-2.916a2.651,2.651,0,0,1,2.943-.972l4.527,12.839c-.291,3.816-.118,5.936-1.474,7.847a17.915,17.915,0,0,0-2.109,3.215,3.65,3.65,0,0,0,.243,3.66c-4.556-.861-8.1-4.331-11.354-7.637l-3.441-3.5a3.1,3.1,0,0,1-.869-1.241c-.33-1.155.74-2.235,1.813-2.774",
    transform: "translate(-47.016 -77.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38682",
    "data-name": "Path 38682",
    d: "M150.5,252.612a2.175,2.175,0,0,0,.452.221,4.2,4.2,0,0,0,1.416.279,4.456,4.456,0,0,0,2.222-.517,4.391,4.391,0,0,0,1.984-2.262,4.53,4.53,0,0,0,.318-1.751,7.219,7.219,0,0,0-.379-1.883,6.832,6.832,0,0,1-.388-1.952,2.3,2.3,0,0,1,.752-1.827,4.173,4.173,0,0,1,2.119-.454,2.116,2.116,0,0,0,1.143-.446,2.073,2.073,0,0,0,.624-1.087,13.153,13.153,0,0,0,.123-2.462,2.636,2.636,0,0,1,.3-1.142,1.651,1.651,0,0,1,.889-.73,4.629,4.629,0,0,1,2.42.009,5.013,5.013,0,0,0,2.483-.052,4.491,4.491,0,0,0,2.037-1.279,7.391,7.391,0,0,0,1.161-1.981,10.418,10.418,0,0,1,.982-1.887,4.629,4.629,0,0,1,1.478-1.3,5.19,5.19,0,0,1,6.073.766,6.317,6.317,0,0,1,1.363,1.775,8.344,8.344,0,0,1,.649,1.81.446.446,0,0,0-.011-.127c-.015-.083-.026-.209-.066-.369a6.04,6.04,0,0,0-.479-1.361,6.282,6.282,0,0,0-1.354-1.839,5.417,5.417,0,0,0-2.673-1.4,5.506,5.506,0,0,0-3.609.551,4.833,4.833,0,0,0-1.563,1.354,10.509,10.509,0,0,0-1.016,1.924,7.2,7.2,0,0,1-1.126,1.91,4.233,4.233,0,0,1-1.921,1.2,4.755,4.755,0,0,1-2.362.041,4.853,4.853,0,0,0-2.56,0,1.92,1.92,0,0,0-1.029.848,2.888,2.888,0,0,0-.336,1.258,13.361,13.361,0,0,1-.112,2.416,1.812,1.812,0,0,1-.538.952,1.861,1.861,0,0,1-1.006.389c-.371.05-.756.049-1.141.1a2.191,2.191,0,0,0-1.1.411,2.528,2.528,0,0,0-.838,2.022,6.955,6.955,0,0,0,.411,2.018,7.082,7.082,0,0,1,.384,1.825,4.342,4.342,0,0,1-.288,1.675,4.248,4.248,0,0,1-1.878,2.2,4.407,4.407,0,0,1-2.148.544,4.976,4.976,0,0,1-1.87-.394",
    transform: "translate(-49.231 -74.997)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38683",
    "data-name": "Path 38683",
    d: "M144.557,242.731a.971.971,0,0,0-.246.325,1.658,1.658,0,0,0-.108,1.158,1.753,1.753,0,0,0,.408.755,1.84,1.84,0,0,0,.884.513,2.308,2.308,0,0,0,2.291-.711,3.091,3.091,0,0,0,.687-1.274,4.322,4.322,0,0,0,.086-1.56,9.5,9.5,0,0,1-.187-3.309,2.136,2.136,0,0,1,.934-1.393,2.336,2.336,0,0,1,1.759-.066,5.656,5.656,0,0,0,1.986.324,1.737,1.737,0,0,0,.976-.454,2.471,2.471,0,0,0,.593-.9,8.206,8.206,0,0,0,.377-2.027,4.507,4.507,0,0,1,.6-1.81,4.809,4.809,0,0,1,2.815-2.161,6.8,6.8,0,0,1,3.286.133,9.472,9.472,0,0,0,2.945.321,6.209,6.209,0,0,0,3.817-1.824,4.366,4.366,0,0,0,.915-1.272,8.481,8.481,0,0,1-.988,1.2,6.18,6.18,0,0,1-1.474,1.05,6.025,6.025,0,0,1-2.286.659,9.4,9.4,0,0,1-2.882-.35,6.975,6.975,0,0,0-3.4-.154,5.047,5.047,0,0,0-2.977,2.266,4.778,4.778,0,0,0-.641,1.91,8.016,8.016,0,0,1-.362,1.962,1.722,1.722,0,0,1-1.353,1.184,5.532,5.532,0,0,1-1.888-.314,2.583,2.583,0,0,0-1.951.1,2.378,2.378,0,0,0-1.047,1.558,4.536,4.536,0,0,0-.043,1.773c.079.564.193,1.1.249,1.618a4.128,4.128,0,0,1-.065,1.484,2.919,2.919,0,0,1-.627,1.2,2.148,2.148,0,0,1-2.113.692,1.714,1.714,0,0,1-.828-.455,1.689,1.689,0,0,1-.343-1.8c.106-.238.209-.338.2-.348",
    transform: "translate(-47.153 -74.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38684",
    "data-name": "Path 38684",
    d: "M209.453,262.623a1.835,1.835,0,0,1-.331,1.163,1.592,1.592,0,0,1-1.183.688,1.671,1.671,0,0,1-1.516-.891,1.535,1.535,0,0,1-.13-1.038,3.208,3.208,0,0,1,.477-1.083,6.807,6.807,0,0,0,1.342-2.386,3.735,3.735,0,0,0-.658-2.948,4.36,4.36,0,0,0-1.191-1.108,6.431,6.431,0,0,0-1.527-.661,8.561,8.561,0,0,1-1.5-.578,2.13,2.13,0,0,1-1-1.073,2.607,2.607,0,0,1-.076-1.437,5.2,5.2,0,0,1,.489-1.344,10.8,10.8,0,0,0,1.108-2.5,4.108,4.108,0,0,0-.208-2.384,5.289,5.289,0,0,0-1.121-1.622,9.934,9.934,0,0,1-.944-1.12,3.093,3.093,0,0,1-.476-1.136s-.006.027,0,.083a1.362,1.362,0,0,0,.03.242,2.469,2.469,0,0,0,.361.869,9.252,9.252,0,0,0,.92,1.162,5.232,5.232,0,0,1,1.056,1.592,3.928,3.928,0,0,1,.168,2.265,10.854,10.854,0,0,1-1.112,2.439,5.438,5.438,0,0,0-.52,1.406,2.863,2.863,0,0,0,.082,1.583,2.383,2.383,0,0,0,1.114,1.211,8.768,8.768,0,0,0,1.546.6,6.252,6.252,0,0,1,1.467.629,4.145,4.145,0,0,1,1.122,1.04,3.486,3.486,0,0,1,.627,2.741,6.711,6.711,0,0,1-1.286,2.316,3.359,3.359,0,0,0-.493,1.165,1.731,1.731,0,0,0,.166,1.167,1.829,1.829,0,0,0,1.694.953,1.763,1.763,0,0,0,1.548-1.676.98.98,0,0,0-.044-.327",
    transform: "translate(-65.752 -78.887)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38685",
    "data-name": "Path 38685",
    d: "M80.5,419.312l13.1-2.78,2.18,10.738-9.626.214.1,8.681c4.322,1.219,4.927,3.4,4.927,3.4l-9.034-.206-7.86-15.983Z",
    transform: "translate(-24.297 -136.253)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170219",
    "data-name": "Group 170219",
    transform: "translate(49.981 286.262)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170218",
    "data-name": "Group 170218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170217",
    "data-name": "Group 170217",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38686",
    "data-name": "Path 38686",
    d: "M74.279,426.289l7.86,15.983,9.033.207-.986-1.381-7.337-.572-7.247-15.1Z",
    transform: "translate(-74.279 -425.423)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38687",
    "data-name": "Path 38687",
    d: "M90.856,439.5c-.069.091-.583-.217-1.282-.213-.7-.017-1.218.283-1.285.191-.083-.07.437-.6,1.289-.589s1.364.542,1.279.611",
    transform: "translate(-28.878 -143.568)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38688",
    "data-name": "Path 38688",
    d: "M90.719,436.081c-.092.062-.482-.481-1.2-.637s-1.3.16-1.357.065c-.03-.042.078-.19.335-.323a1.689,1.689,0,0,1,2.056.46c.176.23.209.41.165.435",
    transform: "translate(-28.838 -142.299)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38689",
    "data-name": "Path 38689",
    d: "M91.044,431.917c-.1.047-.4-.481-1.021-.713s-1.194-.039-1.237-.141c-.023-.045.094-.169.347-.257a1.565,1.565,0,0,1,1.822.689c.131.234.137.4.09.423",
    transform: "translate(-29.042 -140.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38690",
    "data-name": "Path 38690",
    d: "M92.658,431.372c-.11-.027-.042-.6-.313-1.207-.254-.618-.711-.963-.655-1.062.032-.1.7.15,1.02.906s.045,1.412-.052,1.363",
    transform: "translate(-29.991 -140.358)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38691",
    "data-name": "Path 38691",
    d: "M94.541,429.075a3.86,3.86,0,0,1-.213-1.213c-.04-.435-.08-.874-.121-1.323a2.871,2.871,0,0,1,0-.842.732.732,0,0,1,.322-.449.565.565,0,0,1,.615.025,1.676,1.676,0,0,1,.513.8,3.028,3.028,0,0,1-.075,2.184c-.322.737-.775,1-.792.968a10.322,10.322,0,0,0,.529-1.068,3.111,3.111,0,0,0,.137-1.239,2.906,2.906,0,0,0-.164-.711,1.438,1.438,0,0,0-.371-.6.163.163,0,0,0-.189-.014.352.352,0,0,0-.148.21,2.972,2.972,0,0,0-.011.719c.012.451.024.891.036,1.328a3.856,3.856,0,0,1-.068,1.229",
    transform: "translate(-30.805 -139.078)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38692",
    "data-name": "Path 38692",
    d: "M94.909,431.2c-.036-.024.23-.419.925-.645a2.257,2.257,0,0,1,2.563.915.416.416,0,0,1-.039.35.5.5,0,0,1-.237.193,1.38,1.38,0,0,1-.423.085,4.018,4.018,0,0,1-.735,0,3.911,3.911,0,0,1-1.2-.3c-.647-.285-.946-.613-.917-.647.036-.052.387.185,1.015.384a4.447,4.447,0,0,0,1.124.2,4.184,4.184,0,0,0,.67-.02,1.166,1.166,0,0,0,.3-.06c.078-.047.057-.033.056-.061a.7.7,0,0,0-.179-.215,2.057,2.057,0,0,0-.265-.212A2.225,2.225,0,0,0,97,430.88a2.2,2.2,0,0,0-1.092-.057,8.237,8.237,0,0,0-.995.374",
    transform: "translate(-31.026 -140.807)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170222",
    "data-name": "Group 170222",
    transform: "translate(55.05 285.919)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170221",
    "data-name": "Group 170221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170220",
    "data-name": "Group 170220",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38693",
    "data-name": "Path 38693",
    d: "M83.955,426.01a1.072,1.072,0,1,1-1.048-1.095,1.071,1.071,0,0,1,1.048,1.095",
    transform: "translate(-81.811 -424.914)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38694",
    "data-name": "Path 38694",
    d: "M225.637,422.409l-.123,11.828s12.6,4.683,12.786,6.871H214.744l-.565-18.437Z",
    transform: "translate(-70.061 -138.176)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170225",
    "data-name": "Group 170225",
    transform: "translate(147.688 295.204)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170224",
    "data-name": "Group 170224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170223",
    "data-name": "Group 170223",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38695",
    "data-name": "Path 38695",
    d: "M220.13,438.758a.937.937,0,0,0-.62,1.086.9.9,0,0,0,1.071.624.989.989,0,0,0,.651-1.153.934.934,0,0,0-1.186-.526",
    transform: "translate(-219.485 -438.713)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170228",
    "data-name": "Group 170228",
    transform: "translate(144.683 301.072)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170227",
    "data-name": "Group 170227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170226",
    "data-name": "Group 170226",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38696",
    "data-name": "Path 38696",
    d: "M215.018,449.293l.015-1.86,21.991.134s1.646,1,1.549,1.727Z",
    transform: "translate(-215.018 -447.433)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38697",
    "data-name": "Path 38697",
    d: "M230.572,439.753c0,.112-.56.177-1.1.552-.552.36-.823.852-.928.81-.1-.019.046-.693.71-1.135s1.34-.331,1.319-.227",
    transform: "translate(-74.75 -143.818)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38698",
    "data-name": "Path 38698",
    d: "M234.466,441.166c.028.108-.452.311-.82.795s-.466.987-.577.985c-.105.02-.2-.634.271-1.226s1.122-.661,1.127-.554",
    transform: "translate(-76.212 -144.297)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38699",
    "data-name": "Path 38699",
    d: "M237.256,444.465c-.1.026-.271-.529,0-1.15s.79-.879.839-.787c.066.091-.266.428-.481.942s-.248.981-.359.995",
    transform: "translate(-77.562 -144.751)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38700",
    "data-name": "Path 38700",
    d: "M230.012,435.606c-.044.1-.562-.038-1.195.021s-1.12.272-1.182.177.4-.506,1.149-.566,1.28.278,1.227.368",
    transform: "translate(-74.461 -142.37)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170231",
    "data-name": "Group 170231",
    transform: "translate(144.189 286.576)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170230",
    "data-name": "Group 170230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170229",
    "data-name": "Group 170229",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38701",
    "data-name": "Path 38701",
    d: "M225.644,425.891,225.625,428l-11.278.185-.063-1.9Z",
    transform: "translate(-214.284 -425.891)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38702",
    "data-name": "Path 38702",
    d: "M229.428,431.379a2.157,2.157,0,0,1-1.149.024,5.2,5.2,0,0,1-1.211-.338,5.491,5.491,0,0,1-.669-.334,1.415,1.415,0,0,1-.354-.261.488.488,0,0,1-.067-.595.616.616,0,0,1,.485-.269,1.5,1.5,0,0,1,.432.049,4.06,4.06,0,0,1,1.8.9c.545.48.738.893.7.916-.05.038-.318-.306-.87-.7a4.55,4.55,0,0,0-1.04-.551,4.326,4.326,0,0,0-.665-.187c-.244-.057-.451-.054-.511.056-.021.042-.024.058.028.128a1.143,1.143,0,0,0,.26.191,5.848,5.848,0,0,0,.616.331,6.375,6.375,0,0,0,1.122.4,7.848,7.848,0,0,1,1.095.247",
    transform: "translate(-73.897 -140.529)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38703",
    "data-name": "Path 38703",
    d: "M230.764,430.7a1.83,1.83,0,0,1-.331-1.1,3.709,3.709,0,0,1,.124-1.262,3.753,3.753,0,0,1,.275-.705.95.95,0,0,1,.718-.6.538.538,0,0,1,.489.308,1.572,1.572,0,0,1,.129.418,2.571,2.571,0,0,1,.021.774,2.646,2.646,0,0,1-.461,1.2c-.433.606-.9.751-.907.714-.039-.055.346-.281.674-.861a2.638,2.638,0,0,0,.336-1.089,2.358,2.358,0,0,0-.037-.663c-.042-.243-.139-.438-.23-.411-.114,0-.3.19-.392.387a3.836,3.836,0,0,0-.269.63,4.189,4.189,0,0,0-.193,1.153c-.014.674.117,1.09.056,1.109",
    transform: "translate(-75.374 -139.688)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38704",
    "data-name": "Path 38704",
    d: "M123.258,382.279c.807,0,4.668,15.751,4.668,15.751L92.21,403.355,94.476,417.6s42.171-2.818,45.058-3.477c5.144-1.173,9.028-6.146,8.859-12.671-.194-7.512-4.588-25.215-4.588-25.215Z",
    transform: "translate(-30.163 -123.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170234",
    "data-name": "Group 170234",
    transform: "translate(94.831 261.796)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170233",
    "data-name": "Group 170233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170232",
    "data-name": "Group 170232",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38705",
    "data-name": "Path 38705",
    d: "M161.656,389.064l-20.725,1.5s1.722,3.583,7.556,4,14.345,0,14.345,0Z",
    transform: "translate(-140.931 -389.064)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38706",
    "data-name": "Path 38706",
    d: "M200.633,359.915a12.444,12.444,0,0,0-12.486-11.377l-6.351-.005-34.327,1.776-18.629-5.671s-6.476,11.583-2.751,21.261a17.692,17.692,0,0,0,13.689,11.218c7.754,1.32,43.29-6.156,43.29-6.156v31.653l16.122-.415,1.475-41.664q-.009-.311-.032-.618",
    transform: "translate(-40.867 -112.735)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38707",
    "data-name": "Path 38707",
    d: "M182.947,371.238a.962.962,0,0,1-.21.054l-.624.127-2.406.451-8.862,1.6-13.152,2.325-7.768,1.361a33.754,33.754,0,0,1-8.473.482,24.914,24.914,0,0,1-4.267-.677,17.52,17.52,0,0,1-3.946-1.451,15.291,15.291,0,0,1-5.686-5.46,19.337,19.337,0,0,1-2.622-6.655,20.286,20.286,0,0,1-.228-6.23,38.285,38.285,0,0,1,2.337-8.7c.4-.988.753-1.736,1.01-2.234.128-.249.233-.436.307-.559a.949.949,0,0,1,.12-.182,1.084,1.084,0,0,1-.089.2l-.275.574c-.236.507-.57,1.26-.946,2.253a39.884,39.884,0,0,0-2.218,8.678,20.193,20.193,0,0,0,.266,6.147,19.168,19.168,0,0,0,2.609,6.538,15.02,15.02,0,0,0,5.575,5.33,17.277,17.277,0,0,0,3.868,1.415,24.611,24.611,0,0,0,4.21.666,33.668,33.668,0,0,0,8.389-.471l7.77-1.341,13.164-2.251,8.881-1.487,2.418-.387.63-.092a.992.992,0,0,1,.217-.02",
    transform: "translate(-40.746 -113.013)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38708",
    "data-name": "Path 38708",
    d: "M129.926,425.7a.734.734,0,0,1-.173.027l-.513.051-1.986.164-7.419.56L94.39,428.313l-.155.011-.025-.153-1.852-11.613c-.142-.89-.283-1.774-.418-2.629l-.028-.175.175-.026,35.728-5.251.031,0,.028.013a24.973,24.973,0,0,1,5.315,3.492c.558.484.96.886,1.224,1.163l.291.322a.521.521,0,0,1,.091.116.594.594,0,0,1-.111-.1l-.31-.3c-.276-.264-.688-.651-1.254-1.12a26.022,26.022,0,0,0-5.333-3.392l.058.009-35.705,5.4.147-.2c.136.854.277,1.738.419,2.628.64,4.034,1.26,7.948,1.842,11.615l-.18-.142,25.454-1.686,7.425-.46,1.99-.108.514-.021a.716.716,0,0,1,.176,0",
    transform: "translate(-30.066 -133.617)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38709",
    "data-name": "Path 38709",
    d: "M214.874,378.006a7.226,7.226,0,0,0-3.632,3.861c-.041-.009-.024-.328.145-.814a4.976,4.976,0,0,1,2.683-2.853c.475-.2.793-.234.8-.194",
    transform: "translate(-69.094 -123.646)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38710",
    "data-name": "Path 38710",
    d: "M161.852,352.425a5.137,5.137,0,0,1-.957.14c-.619.069-1.517.139-2.628.2-2.222.129-5.295.19-8.685.225s-6.459.086-8.674.211c-1.108.054-2,.124-2.621.176a5.088,5.088,0,0,1-.966.051,5.158,5.158,0,0,1,.949-.187c.616-.093,1.511-.2,2.621-.288,2.22-.188,5.294-.274,8.687-.312s6.46-.058,8.679-.123l2.628-.089a5.08,5.08,0,0,1,.968,0",
    transform: "translate(-44.919 -115.277)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38711",
    "data-name": "Path 38711",
    d: "M152.667,278l-.354.428a13.059,13.059,0,0,0-9.906,9.3c-1.308,4.612-1.706,13.148-4.38,24.712,0,0-6.561,5.939-7.783,10.4l18.949,5.717,10.344-.58,3.989-12.409c3.872,0,5.52-1.941,6.911-5.113,1.852-4.224-4.251-23.613-4.251-23.613l.439,3.312Z",
    transform: "translate(-42.605 -90.936)",
    fill: "#87b825"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170237",
    "data-name": "Group 170237",
    transform: "translate(126.334 203.415)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170236",
    "data-name": "Group 170236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170235",
    "data-name": "Group 170235",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38712",
    "data-name": "Path 38712",
    d: "M187.749,302.3l4.6,9.364-2.829.432s-1.754-9.1-1.772-9.8",
    transform: "translate(-187.749 -302.302)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38713",
    "data-name": "Path 38713",
    d: "M182.486,323.177c-.009-.036.331-.1.892-.353a6.666,6.666,0,0,0,2.087-1.5,8.586,8.586,0,0,0,1.9-3.289,12.522,12.522,0,0,0,.437-4.661,33.556,33.556,0,0,0-.773-4.683c-.318-1.431-.607-2.726-.787-3.826a19.543,19.543,0,0,1-.274-2.625,4.079,4.079,0,0,1,.036-.968,6.766,6.766,0,0,1,.1.959c.056.617.172,1.5.381,2.589s.522,2.368.858,3.8a31.207,31.207,0,0,1,.808,4.729,12.469,12.469,0,0,1-.479,4.785,8.572,8.572,0,0,1-2.034,3.363,6.3,6.3,0,0,1-2.213,1.457,4.293,4.293,0,0,1-.695.2c-.161.032-.247.043-.25.03",
    transform: "translate(-59.694 -98.549)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170240",
    "data-name": "Group 170240",
    transform: "translate(100.819 204.964)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170239",
    "data-name": "Group 170239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170238",
    "data-name": "Group 170238",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38714",
    "data-name": "Path 38714",
    d: "M149.831,304.6s6.406,22.08,10.588,25.442a5.766,5.766,0,0,0,7.768-.056l.773-3.8Z",
    transform: "translate(-149.831 -304.604)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38715",
    "data-name": "Path 38715",
    d: "M225.153,298.678c-.733-.652-1.161-.42-1.161-.42s.39-1.785-.541-2.413c-.286-.193-.443-.294-.524-.343-.1-.237-.674-1.519-1.635-1.739,0,0-.131-1.677-.838-1.834a1.753,1.753,0,0,0-1.9,1.136l-2.417,4.615-1.154,4.688-19.776,9.212,2.119,9.071,22.2-11.468,3.961-3.8s2.4-6.056,1.668-6.708",
    transform: "translate(-63.854 -95.481)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38716",
    "data-name": "Path 38716",
    d: "M152.009,290.884c-.025.707,11.164,29.841,16.448,31.877,2.01.774,32.469-10.642,32.469-10.642l-3.7-11.226s-21.306,7.157-22.014,7.133-7.369-18.462-7.369-18.462-4.181-8.745-10.457-6.019c-4.017,1.745-5.373,7.34-5.373,7.34",
    transform: "translate(-49.724 -92.579)",
    fill: "#65a743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38717",
    "data-name": "Path 38717",
    d: "M175.628,312.988s.131-.058.393-.151l1.161-.4,4.434-1.479,15.982-5.243.137-.045.046.139,3.723,11.22.05.15-.147.057c-4.781,1.843-10.017,3.812-15.5,5.762-3.352,1.189-6.637,2.321-9.842,3.317-1.607.486-3.184.971-4.77,1.317a9.364,9.364,0,0,1-1.194.227l-.6.081a1.631,1.631,0,0,1-.643-.053,4.862,4.862,0,0,1-1.935-1.42,24.256,24.256,0,0,1-2.636-3.681c-.756-1.254-1.436-2.5-2.069-3.718-1.262-2.437-2.336-4.755-3.288-6.884-1.9-4.26-3.29-7.766-4.232-10.2-.47-1.215-.824-2.163-1.059-2.808-.11-.311-.2-.555-.26-.736a1.532,1.532,0,0,1-.077-.255,1.431,1.431,0,0,1,.11.242l.293.723,1.119,2.784c.982,2.412,2.41,5.9,4.332,10.145.964,2.119,2.05,4.428,3.319,6.85.636,1.211,1.318,2.45,2.075,3.693a24.089,24.089,0,0,0,2.609,3.622,4.589,4.589,0,0,0,1.791,1.323,2.661,2.661,0,0,0,1.11-.041,9.2,9.2,0,0,0,1.167-.225c1.564-.346,3.14-.832,4.74-1.319,3.2-1,6.477-2.132,9.827-3.319,5.481-1.948,10.718-3.912,15.5-5.741l-.1.206c-1.323-4.032-2.568-7.826-3.686-11.232l.184.093-16.019,5.125-4.459,1.4-1.174.357c-.266.078-.406.108-.406.108",
    transform: "translate(-50.144 -97.542)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38718",
    "data-name": "Path 38718",
    d: "M162.614,283.393a1.056,1.056,0,0,1,.31-.042,7.688,7.688,0,0,1,.895-.007,6.8,6.8,0,0,1,3.156.917,7.389,7.389,0,0,1,1.735,1.493,17.419,17.419,0,0,1,1.589,2.075,36.9,36.9,0,0,1,2.708,5.312c1.684,3.877,2.909,7.5,3.769,10.127.428,1.314.759,2.382.982,3.121a7.858,7.858,0,0,1,.311,1.161,7.977,7.977,0,0,1-.44-1.118c-.276-.783-.643-1.824-1.088-3.085-.919-2.6-2.178-6.206-3.855-10.066a38.965,38.965,0,0,0-2.658-5.275,17.808,17.808,0,0,0-1.536-2.058,7.263,7.263,0,0,0-1.647-1.475,7.01,7.01,0,0,0-3.037-.992c-.764-.073-1.193-.056-1.194-.087",
    transform: "translate(-53.193 -92.682)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38719",
    "data-name": "Path 38719",
    d: "M233.277,294.77c.084.048-.166.644-.557,1.331s-.778,1.206-.862,1.158.166-.644.557-1.332.778-1.205.862-1.157",
    transform: "translate(-75.839 -96.422)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38720",
    "data-name": "Path 38720",
    d: "M235.335,297.164c.079.058-.21.59-.583,1.229s-.7,1.151-.787,1.11.1-.632.484-1.287.809-1.108.886-1.052",
    transform: "translate(-76.526 -97.204)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38721",
    "data-name": "Path 38721",
    d: "M237.588,301.336c.087.043-.028.46-.256.932s-.484.823-.571.781.028-.46.256-.933.484-.823.572-.781",
    transform: "translate(-77.438 -98.57)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38722",
    "data-name": "Path 38722",
    d: "M185.658,319.749c.087.059-.573,1.076-1.06,2.468s-.627,2.593-.731,2.584a7.113,7.113,0,0,1,1.792-5.053",
    transform: "translate(-60.129 -104.593)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38723",
    "data-name": "Path 38723",
    d: "M192.973,167.826l-5.3-2.146a1.983,1.983,0,0,0,.54,2.619,13.264,13.264,0,0,0,3.15,2.064,9.978,9.978,0,0,0,1.964,4.065c1.36,1.374,4.432-.791,4.432-.791s0-4.027-4.784-5.81",
    transform: "translate(-61.299 -54.196)",
    fill: "#c78976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38724",
    "data-name": "Path 38724",
    d: "M200.551,190.652c-.631-.886-1.263-.36-1.263-.36s.748-1.884-.159-2.738c-.278-.262-.431-.4-.512-.469-.065-.276-.464-1.784-1.476-2.2,0,0-.008-1.774-.759-2.059-1.19-.452-2.524.9-2.524.9l-3.064,4.515-4.563,7.572,2.543,8.083,7.237-4.507,1.442-1.4s3.835-6.311,3.1-7.348",
    transform: "translate(-60.919 -59.776)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38725",
    "data-name": "Path 38725",
    d: "M201.893,185.817c.082.051-.141.562-.5,1.143s-.716,1.011-.8.96.142-.562.5-1.143.716-1.011.8-.96",
    transform: "translate(-65.612 -60.782)",
    fill: "#ffb394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38726",
    "data-name": "Path 38726",
    d: "M203.614,188.906a2.85,2.85,0,0,1-.664,1.755c-.6.876-1.366,1.313-1.413,1.236s.563-.616,1.125-1.435.853-1.585.951-1.556",
    transform: "translate(-65.924 -61.793)",
    fill: "#ffb394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38727",
    "data-name": "Path 38727",
    d: "M204.887,193.531c.087.036-.063.563-.472,1.086s-.881.8-.937.724.284-.452.661-.939.659-.913.749-.871",
    transform: "translate(-66.558 -63.306)",
    fill: "#ffb394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38728",
    "data-name": "Path 38728",
    d: "M184.991,176.365a8.612,8.612,0,0,0,3.214,2.387,2.691,2.691,0,0,0,1.594.267,1.162,1.162,0,0,0,.965-1.147,1.762,1.762,0,0,0-.643-1l-2.4-2.315a5.127,5.127,0,0,0,.955,1.162,1.726,1.726,0,0,0,1.4.418,1.056,1.056,0,0,0,.862-1.071,1.716,1.716,0,0,0-.431-.82l-3.126-3.965",
    transform: "translate(-60.513 -55.702)",
    fill: "#c78976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38729",
    "data-name": "Path 38729",
    d: "M190.707,181.023c.019,0,.037.117-.044.3a1.382,1.382,0,0,1-.586.6,2.439,2.439,0,0,1-1.194.328,2.933,2.933,0,0,1-1.446-.435,6,6,0,0,1-2.56-2.7,14.368,14.368,0,0,0,2.734,2.4,2.822,2.822,0,0,0,1.279.416,2.414,2.414,0,0,0,1.072-.225,1.646,1.646,0,0,0,.745-.682",
    transform: "translate(-60.474 -58.591)",
    fill: "#8b5d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38730",
    "data-name": "Path 38730",
    d: "M191.138,176.47c.016.006,0,.117-.106.285a1.115,1.115,0,0,1-.706.453,3.391,3.391,0,0,1-2.563-.717,6.111,6.111,0,0,1-1.587-2.123,3.058,3.058,0,0,1-.386-1.019,3.79,3.79,0,0,1,.6.9,7.4,7.4,0,0,0,1.585,1.966,3.5,3.5,0,0,0,2.3.75c.635-.082.8-.541.858-.495",
    transform: "translate(-60.772 -56.704)",
    fill: "#8b5d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38731",
    "data-name": "Path 38731",
    d: "M190.11,183.007c.009-.018.133.013.3.162a1.289,1.289,0,0,1,.409.844,1.377,1.377,0,0,1-.639,1.248,1.912,1.912,0,0,1-1.7.041,5.907,5.907,0,0,1-2.43-1.719,2.561,2.561,0,0,1-.63-1.056c.048-.03.3.364.813.89a6.656,6.656,0,0,0,2.367,1.556,1.655,1.655,0,0,0,1.412.013,1.144,1.144,0,0,0,.56-.963,1.292,1.292,0,0,0-.262-.762c-.12-.16-.214-.231-.2-.254",
    transform: "translate(-60.651 -59.707)",
    fill: "#8b5d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38732",
    "data-name": "Path 38732",
    d: "M194.378,174.848a2.352,2.352,0,0,1-1.614-.845,4.362,4.362,0,0,1-1.007-1.739,6.979,6.979,0,0,1-.258-1.156,1.337,1.337,0,0,0-.147-.515.9.9,0,0,0-.429-.3A9.971,9.971,0,0,1,188.8,169.1a3.811,3.811,0,0,1-1.189-1.625,2.331,2.331,0,0,1-.145-1.35c.079-.319.2-.458.217-.448.028.014-.051.172-.083.47a2.44,2.44,0,0,0,.24,1.234,3.748,3.748,0,0,0,1.159,1.466,10.752,10.752,0,0,0,2.075,1.126,1.216,1.216,0,0,1,.577.431,1.617,1.617,0,0,1,.192.653,7.149,7.149,0,0,0,.227,1.109,3.908,3.908,0,0,0,2.312,2.68",
    transform: "translate(-61.307 -54.196)",
    fill: "#8b5d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38733",
    "data-name": "Path 38733",
    d: "M221.226,270.772l4.127-3.2a1.809,1.809,0,0,1,.172,2.434,12.084,12.084,0,0,1-2.256,2.592,9.105,9.105,0,0,1-.721,4.056c-.855,1.543-4.088.4-4.088.4s-1-3.536,2.765-6.286",
    transform: "translate(-71.423 -87.528)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38734",
    "data-name": "Path 38734",
    d: "M229.932,276.447a6.294,6.294,0,0,1-2.032,2.07,2.336,2.336,0,0,1-1.274.111.838.838,0,0,1-.758-.77,1.271,1.271,0,0,1,.405-.754l1.594-1.8a3.687,3.687,0,0,1-.62.89,1.24,1.24,0,0,1-.982.38.761.761,0,0,1-.68-.72,1.24,1.24,0,0,1,.263-.615l2.022-3.028",
    transform: "translate(-73.791 -89.043)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38735",
    "data-name": "Path 38735",
    d: "M230.242,280.617a4.49,4.49,0,0,1-1.985,2,1.511,1.511,0,0,1-1.085.19.9.9,0,0,1-.276-1.58",
    transform: "translate(-74.102 -91.794)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38736",
    "data-name": "Path 38736",
    d: "M226.836,281.228a1.414,1.414,0,0,0-.239.757.794.794,0,0,0,.443.621,1.159,1.159,0,0,0,.974-.094,4.93,4.93,0,0,0,1.606-1.23c.345-.4.513-.689.562-.665s-.053.354-.366.816a4.185,4.185,0,0,1-1.656,1.4,1.421,1.421,0,0,1-1.267.063,1.026,1.026,0,0,1-.544-.9.933.933,0,0,1,.266-.643c.118-.115.209-.139.221-.122",
    transform: "translate(-74.042 -91.793)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38737",
    "data-name": "Path 38737",
    d: "M226.165,279.836c.047-.014.149.276.589.417a1.743,1.743,0,0,0,.765.087,2.023,2.023,0,0,0,.872-.367,14.429,14.429,0,0,0,1.857-1.838,3.92,3.92,0,0,1-1.659,2.128,2.135,2.135,0,0,1-1.038.4,1.769,1.769,0,0,1-.895-.182.992.992,0,0,1-.457-.417c-.066-.137-.053-.224-.033-.227",
    transform: "translate(-73.976 -90.98)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38738",
    "data-name": "Path 38738",
    d: "M225.8,276.865c.05-.04.2.263.648.273a2.552,2.552,0,0,0,1.577-.672,5.584,5.584,0,0,0,1.029-1.482c.221-.422.368-.686.414-.668s-.021.311-.189.769a4.3,4.3,0,0,1-1.019,1.639,2.44,2.44,0,0,1-1.839.659.81.81,0,0,1-.543-.306c-.085-.122-.1-.2-.079-.213",
    transform: "translate(-73.86 -89.732)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38739",
    "data-name": "Path 38739",
    d: "M223.384,277.284a4.16,4.16,0,0,0,1-1.249,4,4,0,0,0,.357-1.677,6.559,6.559,0,0,0-.075-1.028,1.484,1.484,0,0,1,.008-.627,1.123,1.123,0,0,1,.4-.529,9.807,9.807,0,0,0,1.541-1.5,3.417,3.417,0,0,0,.657-1.568,2.231,2.231,0,0,0-.089-1.138c-.1-.255-.207-.375-.184-.4s.157.077.308.337a2.128,2.128,0,0,1,.212,1.226,3.482,3.482,0,0,1-.643,1.728,9.051,9.051,0,0,1-1.575,1.575.8.8,0,0,0-.3.362,1.2,1.2,0,0,0,0,.482,6.371,6.371,0,0,1,.057,1.082,3.976,3.976,0,0,1-.458,1.781c-.528.944-1.221,1.175-1.219,1.136",
    transform: "translate(-73.071 -87.527)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38740",
    "data-name": "Path 38740",
    d: "M177.575,107.936a6.443,6.443,0,0,1,.231,1.8,6.09,6.09,0,0,1-.243,1.982,2.735,2.735,0,0,1-.58,1.077,1.261,1.261,0,0,1-.6.357.928.928,0,0,1-.741-.117,1.9,1.9,0,0,1-.666-1.163c-.1-.4-.171-.781-.226-1.15a12.693,12.693,0,0,1-.141-1.973,5.625,5.625,0,0,1,.206-1.8c.055.006-.007.694.042,1.8a15.66,15.66,0,0,0,.212,1.926c.062.359.142.735.239,1.116a1.634,1.634,0,0,0,.524.954.731.731,0,0,0,.906-.186,2.5,2.5,0,0,0,.518-.938,6.465,6.465,0,0,0,.3-1.881,16.552,16.552,0,0,1,.016-1.8",
    transform: "translate(-57.117 -34.983)",
    fill: "#ffb394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38741",
    "data-name": "Path 38741",
    d: "M181.357,110.923a2.5,2.5,0,0,1,.079.982,4.919,4.919,0,0,1-.56,2.333,2.494,2.494,0,0,1-.434.572.984.984,0,0,1-.67.291,1.047,1.047,0,0,1-.91-.718,1.487,1.487,0,0,1-.048-1c.067-.012.059.4.277.906a.813.813,0,0,0,.68.493c.3,0,.589-.339.8-.717a5.832,5.832,0,0,0,.616-2.176,3.142,3.142,0,0,1,.168-.964",
    transform: "translate(-58.474 -36.284)",
    fill: "#ffb394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38742",
    "data-name": "Path 38742",
    d: "M169.841,119.6c2.137-1.355.348-8.62-.984-10.327,1.461-1.482,2.13-3.144,1.088-4.944-1.352,1.348-3.638,3.023-4.055,6.731l.418,2.827Z",
    transform: "translate(-54.265 -34.128)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38743",
    "data-name": "Path 38743",
    d: "M171.484,116.645a17.182,17.182,0,0,0,.221-1.931,6.818,6.818,0,0,0-1.47-4.3,6.692,6.692,0,0,0-.718-.775l-.158-.145.175-.124a4.167,4.167,0,0,0,1.76-3.284,8.431,8.431,0,0,0-.186-1.576c.018-.007.1.124.2.39a3.846,3.846,0,0,1,.217,1.186,4.159,4.159,0,0,1-.351,1.792,4.35,4.35,0,0,1-1.437,1.774l.016-.269a6.74,6.74,0,0,1,2.2,5.335,6.026,6.026,0,0,1-.256,1.433,1.322,1.322,0,0,1-.213.489",
    transform: "translate(-55.4 -34.188)",
    fill: "#ffb394"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagewithflage);
export default __webpack_public_path__ + "static/media/image with flage.b6856b61118751ff25bb81c0d3e4519a.svg";
export { ForwardRef as ReactComponent };